import React from 'react'
import { image_code } from "./ImageCode"

/* logo */

export const AppLogo = ({
    style = {},
    width = '136',
    className = '',
    height = '136',
    viewBox = '0 0 136 136',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <clipPath>
                <rect width={width} height={height} fill="#fff" stroke="#707070" strokeWidth="1"></rect>
            </clipPath>
            <pattern id="pattern_app_logo" preserveAspectRatio="xMidYMid slice" viewBox="0 0 868 868" width="100%" height="100%">
                <image width="868"
                    height="868"
                    xlinkHref={image_code.LOGO}
                ></image>
            </pattern>
        </defs>
        <g>
            <rect width={width} height={height} fill="url(#pattern_app_logo)"></rect>
        </g>
    </svg >;

/* logo */

export const AppLogoMobile = ({
    style = {},
    width = '136',
    className = '',
    height = '59',
    viewBox = '0 0 136 59',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <clipPath>
                <rect width={width} height={height} fill="#fff" stroke="#707070" strokeWidth="1"></rect>
            </clipPath>
            <pattern id="pattern" preserveAspectRatio="xMidYMid slice" viewBox="0 0 868 868" width="100%" height="100%">
                <image width="868"
                    height="868"
                    xlinkHref={image_code.LOGO}></image>
            </pattern>
        </defs>
        <g>
            <rect width="132.299" height="143" transform="translate(2.776 -84)" fill="url(#pattern)"></rect>
        </g>
    </svg>;
/* arrow right icon on slide */
export const ArrowRightIcon = ({
    style = {},
    fillArrow = '#FFFFFF',
    fill = '#19BC9B',
    width = '60',
    className = '',
    height = '60',
    viewBox = '0 0 60 60',
    d = "M18.34.192a.655.655,0,0,0-.926,0L9.274,8.348,1.117.192a.655.655,0,0,0-.926.926l8.6,8.6a.639.639,0,0,0,.463.192.666.666,0,0,0,.463-.192l8.6-8.6A.641.641,0,0,0,18.34.192Z" }) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <clipPath>
                <rect width="60" height="60" fill="none" />
            </clipPath>
        </defs>
        <g id="right_arrow" data-name="right arrow">
            <g id="Ellipse_65" data-name="Ellipse 65" fill={fill} stroke={fill} strokeWidth="1">
                <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29.5" fill="none" />
            </g>
            <g id="down-arrow-3" transform="translate(27 38.526) rotate(-90)">
                <path id="Path_357" data-name="Path 357" d={d} fill={fillArrow} />
            </g>
        </g>
    </svg>;

/* arrow left icon on slide  */
export const ArrowLeftIcon = ({
    style = {},
    fill = 'none',
    width = '60',
    className = '',
    height = '60',
    viewBox = '0 0 60 60',
    d = "M24.74,33.592a.655.655,0,0,0-.926,0l-8.14,8.156L7.517,33.592a.655.655,0,0,0-.926.926l8.6,8.6a.639.639,0,0,0,.463.192.666.666,0,0,0,.463-.192l8.6-8.6a.641.641,0,0,0,.023-.926Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <clipPath ><rect width="60" height="60" /></clipPath>
        </defs>
        <g>
            <g transform="translate(-2500 -5400)">
                <g fill="#e8e8e8" stroke="#e8e8e8" transform="translate(2500 5400)">
                    <circle stroke="none" cx="30" cy="30" r="30" />
                    <circle fill={fill} cx="30" cy="30" r="29.5" />
                </g>
            </g>
            <g transform="translate(67.31 12.589) rotate(90)">
                <path d={d} />
            </g>
        </g>

    </svg>;

/* check box icon on map */
export const CheckBoxIcon = ({
    style = {},
    fill = 'none',
    width = '18',
    className = '',
    height = '18',
    viewBox = '0 0 18 18',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <image
            width="18"
            height="18"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFTSURBVDhPY/wPBAxUACgG7Xv7mKHr7lmG+98+Mnz++xsqigp4mVkZFLn4GcqUjRmchGWhokgGTXl4kaHtzmmwILGgVsWMIVNeD8IBGXTk3dP/kntm/9c7tOT/6ue3/r/8+Q0kjBWA5EBqQGpBeg6+fQIWBxsUfm4bWHDDi7tgQWIASC1ITwRQLwgwgVx14dNrsOtcRBB+JgRshaTB9LUv78A02KBPf36BOdzAgCQWCLGyg+nXv76DabBB1ACjBhEGYIOEWTnAnHe/f4JpYgBMrQgbJ5gGG6TFKwTmHH73FEwTA2BqdXiEwTTYoGx5fTCn7tZxhjUvbjO8gqYNbAAkB1IDUgsC2QqQvAbPtLMeXWFovnOS4S+RpQozIyNDnYo5Q6qcDpiPUozcARYfsx5dZtj/9gnD0x9foKKoQJaDl8FeWJohTU6XQQVYnMAAlQo2BgYAb6zoIev4CB8AAAAASUVORK5CYII=" />

    </svg>;

/* checked box icon on itinerary map */
export const CheckedBoxIcon = ({
    style = {},
    fill = 'none',
    width = '18',
    className = '',
    height = '18',
    viewBox = '0 0 18 18',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <image
            width="18"
            height="18"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJVSURBVDhPzZXJa1NRFMa/JM1gm3RIYqhDYqQTpIOC1VgXFkE3gmJF3bhSUZTuXWkXKiKuhIqLgv4FLhxAQUkEq5RSIo2ti2pKB9tSapvaGM386rknL6O+VKkLfxDuPeeefLn349wb1SqBf4haHtfF4Nd5pOR9rVtw7PsyTr17hi7fU0SlFMrkPONd+ozb4z5M/FjBt1RCzhZi0mixvbwKl+t2oaNmE876XyKxKsGmL4dBrUHWw7tTftwMDPGX/pSdlVYMhxZhN5jg2XscRvoxFny7PIeTtO2Nug242rAH+81bYaP571iIR/A6OIMrYwMIJeNQq1R4vvsYWk0WXmcPeyf9HFxr7MCJ2gZFMYFYc1fXIiZJHDtodxkxAQsOh75wcNBq57EUSXJI+BaTkhBehYu8ZkGxdUEFebAWt8aH8CEcRFWZjuNFsiCfv2qb/uAc7k2953lv8wGoeFZIScEI9ZU4oiCYiOLSqIfn5+zNivYoCqa9eoEz9IlTn10c8ZJoDI0V1dQJbrnqVxQFJyMh+FYW4KFmd3of4A21lp4a937bIehUygdTXKmn2/Co/QgqZfMFN5r2oY7ypWBBi9bAgThSPi6jGU/aj6JGq8dhmxOnNzfJK7laa1HPsqDLZOagPzjLYz7Cs8ckesfVKWfSZGpbjLmmFrBg97YdHPR8HMDD+U98vfIRxxf3VCDWRI2oFXQ723jMkH0c+qZHcT0wmH3X1kJDd7in3o3zjhY5k6bgxQ7Qs9U3PYJXSzOYjYblbCHiZem0bMEFRyvvvJj/8y8gB/AT6WvciKenmv4AAAAASUVORK5CYII=" />
    </svg>;

/* ellipsis icon menu of member area */
export const EllipsisVIcon = ({
    style = {},
    fill = '#FFFFFF',
    width = '7.258',
    className = '',
    height = '25',
    viewBox = '0 0 7.258 25',
    d = "M27.629,16.871A3.629,3.629,0,1,1,24,20.5,3.627,3.627,0,0,1,27.629,16.871ZM24,11.629A3.629,3.629,0,1,0,27.629,8,3.627,3.627,0,0,0,24,11.629Zm0,17.742a3.629,3.629,0,1,0,3.629-3.629A3.627,3.627,0,0,0,24,29.371Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>;

export const EllipsisHIcon = ({
    style = {},
    fill = '#FFFFFF',
    width = '25',
    className = '',
    height = '7.258',
    viewBox = '0 0 512 512',
    d = "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>;

/* address map icon on map */
export const AddressMapIcon = ({
    style = {
        marginLeft: "2px",
        marginRight: "13px",
    },
    fill = '#707070',
    width = '12.75',
    className = '',
    height = '17',
    viewBox = '0 0 12.75 17',
    d = "M5.72,16.657C.9,9.663,0,8.945,0,6.375a6.375,6.375,0,0,1,12.75,0c0,2.57-.9,3.288-5.72,10.282a.8.8,0,0,1-1.31,0Zm.655-7.626A2.656,2.656,0,1,0,3.719,6.375,2.656,2.656,0,0,0,6.375,9.031Z"

}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* th icon destination */
export const ThIcon = ({
    style = {},
    fill = 'var(--lightGray)',
    width = '25',
    className = '',
    height = '25',
    viewBox = '0 0 512 512',
    d = "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;


/* th icon on map */
export const AngleRightIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '12',
    className = '',
    height = '12',
    viewBox = '0 0 192 512',
    d = "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* list icon on map */
export const ListIcon = ({
    style = {},
    fill = '#707070',
    width = '25',
    className = '',
    height = '25',
    viewBox = '0 0 512 512',
    d = "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* bars icon on map */
export const BarsIcon = ({
    style = {},
    fill = '#707070',
    width = '21.875',
    className = '',
    height = '25',
    viewBox = '0 0 448 512',
    d = "M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;
//flights Bar icon

export const FlightsBarsIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '21.875',
    className = '',
    height = '25',
    viewBox = '0 0 448 512',
    d = "M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* display tour icon*/
export const GlobeIcon = ({
    style = {
        marginLeft: "2px",
        marginRight: "13px",
    },
    fill = '#707070',
    width = '15',
    className = '',
    height = '17',
    viewBox = '0 0 448 512',
    d = "M208.07 352c88.4 0 160.06-71.63 160.06-160 0-88.32-71.61-160-160.06-160-88.4 0-160.06 71.63-160.06 160 .01 88.31 71.61 160 160.06 160zm0-272c61.88 0 112.04 50.14 112.04 112s-50.16 112-112.04 112S96.03 253.86 96.03 192 146.19 80 208.07 80zm140.05 384H248.09v-35.53c47.5-7.92 93.08-30.1 129.75-66.77 85.25-85.22 92.73-218.44 22.91-312.38l10.7-10.7c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.3c-6.25-6.25-16.38-6.25-22.64 0L334.47 47.7c3.17 2.79 6.39 5.52 9.41 8.53 36.28 36.26 56.26 84.48 56.26 135.77s-19.98 99.5-56.26 135.76S259.37 384 208.07 384s-99.53-19.97-135.81-56.24c-3.02-3.02-5.75-6.23-8.53-9.41L4.69 377.38c-6.25 6.25-6.25 16.38 0 22.63L16 411.31c6.25 6.25 16.38 6.25 22.64 0l26.71-26.7c40.03 29.72 87.18 45.3 134.72 46.95V464H100.03c-19.89 0-36.01 16.12-36.01 36 0 6.63 5.37 12 12 12h296.1c6.63 0 12-5.37 12-12 .01-19.88-16.11-36-36-36z",

}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* copy icon on member's  menu  */
export const CopyIcon = ({
    style = {
        marginRight: "15px",
    },
    fill = '#707070',
    width = '14.875',
    className = '',
    height = '17',
    viewBox = '0 0 14.875 17',
    d = "M10.625,14.875V16.2a.8.8,0,0,1-.8.8H.8a.8.8,0,0,1-.8-.8V3.984a.8.8,0,0,1,.8-.8H3.188v9.828a1.861,1.861,0,0,0,1.859,1.859Zm0-11.422V0H5.047a.8.8,0,0,0-.8.8V13.016a.8.8,0,0,0,.8.8h9.031a.8.8,0,0,0,.8-.8V4.25H11.422A.8.8,0,0,1,10.625,3.453Zm4.017-1.03L12.452.233A.8.8,0,0,0,11.889,0h-.2V3.188h3.188v-.2a.8.8,0,0,0-.233-.563Z"

}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* print icon */
export const PrintIcon = ({
    style = {
        marginRight: "15px",
    },
    fill = '#707070',
    width = '17',
    className = '',
    height = '17',
    viewBox = '0 0 17 17',
    d = "M14.875,6.375V2.565a1.063,1.063,0,0,0-.311-.751l-1.5-1.5A1.063,1.063,0,0,0,12.31,0H3.188A1.063,1.063,0,0,0,2.125,1.063V6.375A2.125,2.125,0,0,0,0,8.5v3.719a.531.531,0,0,0,.531.531H2.125v3.188A1.063,1.063,0,0,0,3.188,17H13.813a1.063,1.063,0,0,0,1.063-1.062V12.75h1.594A.531.531,0,0,0,17,12.219V8.5A2.125,2.125,0,0,0,14.875,6.375Zm-2.125,8.5H4.25V11.688h8.5Zm0-7.437H4.25V2.125h6.375V3.719a.531.531,0,0,0,.531.531H12.75Zm1.594,2.391a.8.8,0,1,1,.8-.8A.8.8,0,0,1,14.344,9.828Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/* share icon */
export const ShareIcon = ({
    style = {
        marginRight: "15px",
    },
    fill = '#707070',
    width = '17',
    className = '',
    height = '17',
    viewBox = '0 0 19.429 17',
    d = "M19.113,37.989l-6.679-5.767a.911.911,0,0,0-1.506.689v3.038C4.833,36.019,0,37.24,0,43.017a7.757,7.757,0,0,0,3.162,5.849.676.676,0,0,0,1.065-.707c-1.721-5.5.816-6.964,6.7-7.048v3.336a.911.911,0,0,0,1.506.689l6.679-5.768A.911.911,0,0,0,19.113,37.989Z",
    transform = "translate(0 -32)"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} transform={transform} />
    </svg>;

/* calendar duotone icon on menu */
export const CalendarDuotoneIcon = ({
    style = {
        display: "inline-block",
        fontSize: "inherit",

        overflow: "visible",
        verticalAlign: "-0.125em",
        marginRight: "10px",
    },
    className = '',
    fill_path = '#707070',
    width = "20",
    height = '20',
    viewBox = '0 0 448 512',
    d1 = "M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm128 244a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm128 128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm128 128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm-80-180h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z",
    d2 = "M448 112v80H0v-80a48 48 0 0 1 48-48h48v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h128v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h48a48 48 0 0 1 48 48z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill_path}
            />
            <path
                d={d2}
                fill={fill_path}
            />
        </g>
    </svg>;

/* calendar day icon on map */
export const CalendarDayDuotoneIcon = ({
    style = {
        display: "inline-block",
        fontSize: "inherit",

        overflow: "visible",
        verticalAlign: "-0.125em",
        marginRight: "10px",
    },
    className = '',
    fill_path = '#707070',
    width = "20",
    height = '20',
    viewBox = '0 0 448 512',
    d1 = "M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm192 176a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16zm112-240h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z",
    d2 = "M448 112v80H0v-80a48 48 0 0 1 48-48h48v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h128v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h48a48 48 0 0 1 48 48z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill_path}
            />
            <path
                d={d2}
                fill={fill_path}
            />
        </g>
    </svg>;

/* list  ui icon */
export const ListULIcon = ({
    style = {
        marginRight: "10px",
    },
    fill = '#707070',
    width = "20",
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d = "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} />
    </svg>;

/*  watch icon */
export const WatchDuotoneIcon = ({
    style = {
        display: "inline-block",

        overflow: "visible",
        verticalAlign: "-0.125em",
        marginRight: "10px",
    },
    className = '',
    fill_path = '#707070',
    width = "20",
    height = '20',
    viewBox = '0 0 384 512',
    d1 = "M320 80H64a64 64 0 0 0-64 64v224a64 64 0 0 0 64 64h256a64 64 0 0 0 64-64V144a64 64 0 0 0-64-64zM120 368a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8z",
    d2 = "M64 480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-48H64zM288 0H96a32 32 0 0 0-32 32v48h256V32a32 32 0 0 0-32-32zM72 368a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H80a8 8 0 0 0-8 8zm8-88h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H80a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm88 88a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8zm8-88h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm88 88a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8zm8-88h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill_path}
            />
            <path
                d={d2}
                fill={fill_path}
            />
        </g>
    </svg>;

/* eraser icon */
export const EraserDuotoneIcon = ({
    style = {
        display: "inline-block",

        overflow: "visible",
        verticalAlign: "-0.125em",
        marginRight: "10px",
    },
    className = '',
    fill_path = '#707070',
    width = "20",
    height = '20',
    viewBox = '0 0 512 512',
    d1 = "M512 428v40a12 12 0 0 1-12 12H144a48 48 0 0 1-33.94-14.06l-96-96a48 48 0 0 1 0-67.88l136-136 227.88 227.88L355.88 416H500a12 12 0 0 1 12 12z",
    d2 = "M377.94 393.94l120-120a48 48 0 0 0 0-67.88l-160-160a48 48 0 0 0-67.88 0l-120 120 45.25 45.25z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill_path}
            />
            <path
                d={d2}
                fill={fill_path}
            />
        </g>
    </svg>;

/* cogs icon  */
export const CogsIcon = ({
    style = {
        display: "inline-block",
        fontSize: "inherit",

        overflow: "visible",
        verticalAlign: "-0.125em",
        marginRight: "10px",
    },
    className = '',
    fill_path = '#707070',
    width = "20",
    height = '20',
    viewBox = '0 0 640 512',
    d1 = "M638.41 387a12.34 12.34 0 0 0-12.2-10.3h-16.5a86.33 86.33 0 0 0-15.9-27.4L602 335a12.42 12.42 0 0 0-2.8-15.7 110.5 110.5 0 0 0-32.1-18.6 12.36 12.36 0 0 0-15.1 5.4l-8.2 14.3a88.86 88.86 0 0 0-31.7 0l-8.2-14.3a12.36 12.36 0 0 0-15.1-5.4 111.83 111.83 0 0 0-32.1 18.6 12.3 12.3 0 0 0-2.8 15.7l8.2 14.3a86.33 86.33 0 0 0-15.9 27.4h-16.5a12.43 12.43 0 0 0-12.2 10.4 112.66 112.66 0 0 0 0 37.1 12.34 12.34 0 0 0 12.2 10.3h16.5a86.33 86.33 0 0 0 15.9 27.4l-8.2 14.3a12.42 12.42 0 0 0 2.8 15.7 110.5 110.5 0 0 0 32.1 18.6 12.36 12.36 0 0 0 15.1-5.4l8.2-14.3a88.86 88.86 0 0 0 31.7 0l8.2 14.3a12.36 12.36 0 0 0 15.1 5.4 111.83 111.83 0 0 0 32.1-18.6 12.3 12.3 0 0 0 2.8-15.7l-8.2-14.3a86.33 86.33 0 0 0 15.9-27.4h16.5a12.43 12.43 0 0 0 12.2-10.4 112.66 112.66 0 0 0 .01-37.1zm-136.8 44.9c-29.6-38.5 14.3-82.4 52.8-52.8 29.59 38.49-14.3 82.39-52.8 52.79zm136.8-343.8a12.34 12.34 0 0 0-12.2-10.3h-16.5a86.33 86.33 0 0 0-15.9-27.4l8.2-14.3a12.42 12.42 0 0 0-2.8-15.7 110.5 110.5 0 0 0-32.1-18.6A12.36 12.36 0 0 0 552 7.19l-8.2 14.3a88.86 88.86 0 0 0-31.7 0l-8.2-14.3a12.36 12.36 0 0 0-15.1-5.4 111.83 111.83 0 0 0-32.1 18.6 12.3 12.3 0 0 0-2.8 15.7l8.2 14.3a86.33 86.33 0 0 0-15.9 27.4h-16.5a12.43 12.43 0 0 0-12.2 10.4 112.66 112.66 0 0 0 0 37.1 12.34 12.34 0 0 0 12.2 10.3h16.5a86.33 86.33 0 0 0 15.9 27.4l-8.2 14.3a12.42 12.42 0 0 0 2.8 15.7 110.5 110.5 0 0 0 32.1 18.6 12.36 12.36 0 0 0 15.1-5.4l8.2-14.3a88.86 88.86 0 0 0 31.7 0l8.2 14.3a12.36 12.36 0 0 0 15.1 5.4 111.83 111.83 0 0 0 32.1-18.6 12.3 12.3 0 0 0 2.8-15.7l-8.2-14.3a86.33 86.33 0 0 0 15.9-27.4h16.5a12.43 12.43 0 0 0 12.2-10.4 112.66 112.66 0 0 0 .01-37.1zm-136.8 45c-29.6-38.5 14.3-82.5 52.8-52.8 29.59 38.49-14.3 82.39-52.8 52.79z",
    d2 = "M420 303.79L386.31 287a173.78 173.78 0 0 0 0-63.5l33.7-16.8c10.1-5.9 14-18.2 10-29.1-8.9-24.2-25.9-46.4-42.1-65.8a23.93 23.93 0 0 0-30.3-5.3l-29.1 16.8a173.66 173.66 0 0 0-54.9-31.7V58a24 24 0 0 0-20-23.6 228.06 228.06 0 0 0-76 .1A23.82 23.82 0 0 0 158 58v33.7a171.78 171.78 0 0 0-54.9 31.7L74 106.59a23.91 23.91 0 0 0-30.3 5.3c-16.2 19.4-33.3 41.6-42.2 65.8a23.84 23.84 0 0 0 10.5 29l33.3 16.9a173.24 173.24 0 0 0 0 63.4L12 303.79a24.13 24.13 0 0 0-10.5 29.1c8.9 24.1 26 46.3 42.2 65.7a23.93 23.93 0 0 0 30.3 5.3l29.1-16.7a173.66 173.66 0 0 0 54.9 31.7v33.6a24 24 0 0 0 20 23.6 224.88 224.88 0 0 0 75.9 0 23.93 23.93 0 0 0 19.7-23.6v-33.6a171.78 171.78 0 0 0 54.9-31.7l29.1 16.8a23.91 23.91 0 0 0 30.3-5.3c16.2-19.4 33.7-41.6 42.6-65.8a24 24 0 0 0-10.5-29.1zm-151.3 4.3c-77 59.2-164.9-28.7-105.7-105.7 77-59.2 164.91 28.7 105.71 105.7z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill_path}
            />
            <path
                d={d2}
                fill={fill_path}
            />
        </g>
    </svg>;

export const CameraRetroIcon = ({
    style = {
        display: "inline-block",
        fontSize: "inherit",
    },
    className = '',
    fill = '#707070',
    width = "30",
    height = '30',
    viewBox = '0 0 512 512',
    d1 = "M256 232a88 88 0 1 0 88 88 88 88 0 0 0-88-88zm0 56a32.09 32.09 0 0 0-32 32 16 16 0 0 1-32 0 64.06 64.06 0 0 1 64-64 16 16 0 0 1 0 32zM480 32H256l-64 48H16A16 16 0 0 0 0 96v64h512V64a32.09 32.09 0 0 0-32-32z",
    d2 = "M176 48a16 16 0 0 0-16-16H64a16 16 0 0 0-16 16v32h128zM0 160v272a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V160zm256 280a120 120 0 1 1 120-120 120 120 0 0 1-120 120z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d1}
                fill={fill}
            />
            <path
                d={d2}
                fill={fill}
            />
        </g>
    </svg>;

/* delete icon */
export const DeleteIcon = ({
    style = {
        marginRight: "15px",
    },
    fill = '#707070',
    width = '14.875',
    className = '',
    height = '17',
    viewBox = '0 0 14.875 17',
    d = "M1.062,15.406A1.594,1.594,0,0,0,2.656,17h9.562a1.594,1.594,0,0,0,1.594-1.594V4.25H1.062Zm9.031-8.5a.531.531,0,0,1,1.063,0v7.437a.531.531,0,0,1-1.062,0Zm-3.187,0a.531.531,0,0,1,1.062,0v7.437a.531.531,0,1,1-1.062,0Zm-3.187,0a.531.531,0,0,1,1.062,0v7.437a.531.531,0,1,1-1.062,0ZM14.344,1.062H10.359L10.047.441A.8.8,0,0,0,9.333,0h-3.8a.788.788,0,0,0-.711.442l-.312.621H.531A.531.531,0,0,0,0,1.594V2.656a.531.531,0,0,0,.531.531H14.344a.531.531,0,0,0,.531-.531V1.594A.531.531,0,0,0,14.344,1.062Z",
    transform = "translate(0 0)"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} transform={transform} />
    </svg>;

/* times icon */
export const TimesIcon = ({
    style = {},
    fill = '#C7C7C7',
    width = "20",
    className = '',
    height = '20',
    viewBox = '0 0 20 20',
    d = "M13.791,90l5.686-5.686a1.787,1.787,0,0,0,0-2.527l-1.264-1.264a1.787,1.787,0,0,0-2.527,0L10,86.209,4.314,80.523a1.787,1.787,0,0,0-2.527,0L.523,81.787a1.787,1.787,0,0,0,0,2.527L6.209,90,.523,95.686a1.787,1.787,0,0,0,0,2.527l1.264,1.264a1.787,1.787,0,0,0,2.527,0L10,93.791l5.686,5.686a1.787,1.787,0,0,0,2.527,0l1.264-1.264a1.787,1.787,0,0,0,0-2.527Z",
    transform = "translate(0 -80)"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} transform={transform} />
    </svg>;

/* times map icon */
export const TimesMapIcon = ({
    style = {},
    fill = '#19BC9B',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 20 20',
    d = "M13.791,90l5.686-5.686a1.787,1.787,0,0,0,0-2.527l-1.264-1.264a1.787,1.787,0,0,0-2.527,0L10,86.209,4.314,80.523a1.787,1.787,0,0,0-2.527,0L.523,81.787a1.787,1.787,0,0,0,0,2.527L6.209,90,.523,95.686a1.787,1.787,0,0,0,0,2.527l1.264,1.264a1.787,1.787,0,0,0,2.527,0L10,93.791l5.686,5.686a1.787,1.787,0,0,0,2.527,0l1.264-1.264a1.787,1.787,0,0,0,0-2.527Z",
    transform = "translate(0 -80)"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d={d} fill={fill} transform={transform} />
    </svg>;


/* facebook icon  */
export const FacebookIcon = ({
    style = {},
    fill_f = '#e8e8e8',
    fill_circle = '#19BC9B',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 30 30',
    d = "M46.472,31.531H43.8v9.806H39.741V31.531H37.812V28.085h1.929v-2.23a3.8,3.8,0,0,1,4.091-4.092l3,.013v3.345H44.656a.825.825,0,0,0-.86.939v2.028h3.031Z",
    transform = "translate(-27.701 -15.944)"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle cx="15" cy="15" r="15" fill={fill_circle} />
        <path
            d={d}
            fill={fill_f}
            transform={transform}
        />
    </svg>;

/* instagram icon */
export const InstagramIcon = ({
    style = {},
    fill = '#19BC9B',
    fill_circle = '#e8e8e8',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 30 30',
    d1 = 'M35.289,23.88H26.347a2.591,2.591,0,0,0-2.588,2.588V35.41A2.592,2.592,0,0,0,26.347,38h8.941a2.592,2.592,0,0,0,2.589-2.589V26.468a2.591,2.591,0,0,0-2.588-2.588ZM30.818,35.587a4.648,4.648,0,1,1,4.648-4.648,4.648,4.648,0,0,1-4.648,4.648Zm4.8-8.334a1.1,1.1,0,1,1,.776-.322,1.1,1.1,0,0,1-.776.322Z',
    transform1 = 'translate(-15.818 -15.899)',
    d2 = 'M39.533,36.971a2.684,2.684,0,1,0,2.684,2.683A2.684,2.684,0,0,0,39.533,36.971Z',
    transform2 = 'translate(-24.533 -24.614)',
    d3 = 'M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm9.023,19.511a4.557,4.557,0,0,1-4.552,4.552H10.529a4.557,4.557,0,0,1-4.552-4.552V10.57a4.557,4.557,0,0,1,4.552-4.552H19.47a4.557,4.557,0,0,1,4.552,4.552Z',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle cx="15" cy="15" r="15" fill={fill_circle} />
        <path
            d={d1}
            fill={fill}
            transform={transform1}
        />
        <path
            d={d2}
            fill={fill}
            transform={transform2}
        />
        <path
            d={d3}
            fill={fill}
        />
    </svg>;

/* pinterest icon */
export const PinterestIcon = ({
    style = {},
    fill_circle = '#19BC9B',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 30 30',
    transform_path = "translate(-29 -24.593)",
    d = 'M37.457,38.1a5.072,5.072,0,0,1-2.5-1.19c-.489,2.565-1.086,5.023-2.855,6.307-.547-3.876.8-6.787,1.428-9.878-1.067-1.8.128-5.414,2.38-4.522,2.771,1.1-2.4,6.681,1.072,7.379,3.623.728,5.1-6.287,2.855-8.569-3.247-3.3-9.45-.075-8.687,4.641.186,1.153,1.377,1.5.476,3.094-2.078-.46-2.7-2.1-2.618-4.284a6.992,6.992,0,0,1,6.308-6.427c3.913-.438,7.586,1.437,8.093,5.118.57,4.154-1.767,8.654-5.951,8.331Z',
    fill_path = "#e8e8e8",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-0.002 -0.002)">
            <circle cx="15" cy="15" r="15" fill={fill_circle} />
            <g transform="translate(7.755 6.577)">
                <path
                    d={d}
                    fill={fill_path}
                    transform={transform_path}
                />
            </g>
        </g>
    </svg>;

/* snapchat icon */
export const SnapchatIcon = ({
    style = {},
    fill_circle = '#e8e8e8',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 30 30',
    d = 'M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm8.983,19.843c-.108.252-.594.61-2.292.872-.139.021-.193.2-.276.582-.03.138-.061.274-.1.416a.227.227,0,0,1-.243.182h-.021a2.13,2.13,0,0,1-.38-.048,5.09,5.09,0,0,0-1.021-.108,4.534,4.534,0,0,0-.737.062,3.53,3.53,0,0,0-1.4.715,3.955,3.955,0,0,1-2.425.957H14.86a3.952,3.952,0,0,1-2.423-.956,3.539,3.539,0,0,0-1.4-.715,4.528,4.528,0,0,0-.736-.062,5.046,5.046,0,0,0-1.021.115,2.234,2.234,0,0,1-.38.055.239.239,0,0,1-.264-.189c-.042-.144-.073-.284-.1-.419-.076-.347-.13-.561-.275-.584-1.7-.262-2.185-.62-2.293-.874a.326.326,0,0,1-.026-.108.191.191,0,0,1,.16-.2,5.63,5.63,0,0,0,3.831-3.212v-.009a1,1,0,0,0,.093-.836c-.179-.422-.764-.608-1.151-.73-.1-.03-.184-.058-.255-.087-.772-.305-.836-.618-.806-.778a.729.729,0,0,1,.709-.462.5.5,0,0,1,.211.042,2.253,2.253,0,0,0,.931.245.767.767,0,0,0,.556-.177c-.01-.177-.022-.361-.033-.552A9.13,9.13,0,0,1,10.4,9.336a4.724,4.724,0,0,1,4.386-2.829h.364a4.731,4.731,0,0,1,4.393,2.83,9.14,9.14,0,0,1,.216,3.645v.054c-.011.172-.021.339-.03.5a.744.744,0,0,0,.507.176h0a2.334,2.334,0,0,0,.877-.244.656.656,0,0,1,.272-.054.837.837,0,0,1,.313.06H21.7a.576.576,0,0,1,.438.469c0,.181-.135.453-.812.72-.07.028-.16.056-.255.086-.387.123-.971.309-1.151.73a.994.994,0,0,0,.093.835v.009a5.626,5.626,0,0,0,3.831,3.212.191.191,0,0,1,.16.2A.32.32,0,0,1,23.983,19.843Zm0,0',
    fill_path = "#19BC9B",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle cx="15" cy="15" r="15" fill={fill_circle} />
        <path
            d={d}
            fill={fill_path}
        />
    </svg>;

/* twitter icon */
export const TwitterIcon = ({
    style = {},
    fill_circle = '#19BC9B',
    width = "30",
    className = '',
    height = '30',
    viewBox = '0 0 30 30',
    transform_path = "translate(-25.103 -34.028)",
    d = 'M42.579,35.709a7.154,7.154,0,0,1-2.059.564A3.6,3.6,0,0,0,42.1,34.29a7.178,7.178,0,0,1-2.277.87,3.588,3.588,0,0,0-6.11,3.271,10.178,10.178,0,0,1-7.39-3.747,3.589,3.589,0,0,0,1.109,4.787,3.56,3.56,0,0,1-1.624-.449q0,.023,0,.045a3.588,3.588,0,0,0,2.876,3.515,3.6,3.6,0,0,1-1.619.062,3.589,3.589,0,0,0,3.349,2.49A7.238,7.238,0,0,1,25.1,46.619a10.2,10.2,0,0,0,15.7-8.591c0-.155,0-.31-.01-.464a7.271,7.271,0,0,0,1.789-1.856Z',
    fill_path = '#e8e8e8',
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-0.002)">
            <circle cx="15" cy="15" r="15" fill={fill_circle} transform="translate(0.001)" />
            <g transform="translate(6.713 9.099)">
                <path
                    d={d}
                    fill={fill_path}
                    transform={transform_path}
                />
            </g>
        </g>
    </svg>;

/* air plane */
export const AirPlane = ({
    style = {},
    fill_path = '#19BC9B',
    width = "49.056",
    className = '',
    height = '47.469',
    viewBox = '0 0 49.056 47.469',
    transform_path1 = "translate(-8.285)",
    d1 = "M55.332,22.286,49.4,19.592V15.8a.719.719,0,0,0-.719-.719H42.336a.719.719,0,0,0-.719.719v.255l-3.325-1.511V8.291A8.619,8.619,0,0,0,32.234.033a.718.718,0,0,0-.431,0,8.619,8.619,0,0,0-6.059,8.258v6.25L22.42,16.053V15.8a.719.719,0,0,0-.719-.719H15.353a.719.719,0,0,0-.719.719v3.794L8.706,22.286a.719.719,0,0,0-.421.654V27.7A.719.719,0,0,0,9,28.421h5.7a3.892,3.892,0,0,0,7.651,0h3.392v8.8a.718.718,0,0,0,.058.283l.474,1.107-5.049,4.418-.014.014-.032.031-.02.022-.028.034-.017.023c-.009.012-.017.025-.025.038l-.014.023c-.008.014-.016.029-.023.044l-.01.021c-.007.017-.014.034-.02.051l-.007.018a.512.512,0,0,0-.015.056c0,.019,0,.01,0,.015s-.007.04-.01.061V43.5a.736.736,0,0,0,0,.076v2.381a.719.719,0,0,0,.719.719h8.029l.834,1.945a.719.719,0,0,0,.661.436h1.587a.719.719,0,0,0,.661-.435l.834-1.945h8.029a.719.719,0,0,0,.719-.719V43.575a.709.709,0,0,0,0-.076v-.014a.311.311,0,0,0-.01-.061v-.015a.2.2,0,0,0-.015-.057l-.007-.018c-.006-.017-.013-.034-.02-.051l-.01-.02c-.007-.015-.015-.03-.023-.044l-.014-.023-.025-.038-.018-.024-.028-.033-.021-.023-.031-.031-.014-.014L37.76,38.616l.474-1.107a.719.719,0,0,0,.058-.283V28.421h3.392a3.892,3.892,0,0,0,7.651,0h5.7a.719.719,0,0,0,.719-.719V22.941a.718.718,0,0,0-.422-.655Zm-43.079,4.7H9.722V26.04h2.531Zm0-2.381H9.722V23.4l2.531-1.151ZM32.019,1.475a7.248,7.248,0,0,1,1.772.906H30.247a7.239,7.239,0,0,1,1.772-.906ZM16.071,16.516h4.912v.19l-4.912,2.233Zm-2.38,10.468V26.04h4.118v.944Zm4.837,3.175a2.46,2.46,0,0,1-2.348-1.737h4.7a2.46,2.46,0,0,1-2.353,1.736Zm4.043-3.175H19.246V26.04h3.325Zm3.175,0H24.008V26.04h1.737ZM26.873,40,28.1,42.856H23.614Zm-4.452,5.233v-.944h6.29l.4.944Zm11.773-1.946V43.3l-1.017,2.374v.007l-.432,1.008V37.226a.719.719,0,1,0-1.437,0v9.462l-.432-1.008v-.008L29.848,43.3v-.008L27.8,38.526V38.52l-.618-1.441V27.7h0V22.55a.719.719,0,1,0-1.437,0V24.6H13.691v-3l12.054-5.48v3.559a.719.719,0,1,0,1.437,0V8.291a7.2,7.2,0,0,1,1.544-4.473h6.586a7.2,7.2,0,0,1,1.544,4.473V37.078l-.617,1.44v.01Zm7.424,1.946H34.923l.4-.944h6.29Zm-1.194-2.381H35.943L37.165,40Zm2.631-26.34h4.912v2.422L43.055,16.7ZM40.031,26.984H38.293V26.04H40.03Zm1.437,0V26.04h3.325v.944Zm4.043,3.175a2.46,2.46,0,0,1-2.349-1.737h4.7a2.46,2.46,0,0,1-2.351,1.736Zm4.837-3.175H46.23V26.04h4.118Zm0-2.381H38.293V16.12L50.348,21.6Zm3.968,2.381H51.785V26.04h2.531ZM51.785,24.6V22.25l2.531,1.15v1.2Z",
    d2 = "M219.262,49.7a3.9,3.9,0,0,0-3.893,3.893.719.719,0,0,0,1.437,0,2.456,2.456,0,1,1,4.912,0,.719.719,0,1,0,1.437,0,3.9,3.9,0,0,0-3.893-3.893Z",

}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(49.056 -8.285) rotate(90)">
            <g transform="translate(8.285)">
                <path
                    d={d1}
                    fill={fill_path}
                    transform={transform_path1}
                />
            </g>
            <g transform="translate(28.126 4.762)">
                <path
                    d={d2}
                    fill={fill_path}
                    transform="translate(-215.369 -49.698)"
                />
            </g>
        </g>
    </svg>;

/* star */
export const StarIcon = ({
    style = {},
    fill = '#19BC9B',
    width = "30",
    className = '',
    height = '25',
    viewBox = '0 0 576 512',
    d = "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
        />
    </svg>;

/* star empty */
export const StarEmptyIcon = ({
    style = {},
    fill = '#FFFFFF',
    width = "30",
    className = '',
    height = '25',
    viewBox = '0 0 576 512',
    d = "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
        />
    </svg>;

/* camera icon */
export const CameraIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "17",
    height = "14.875",
    viewBox = "0 0 17 14.875",
    d = "M17,35.719v9.563a1.594,1.594,0,0,1-1.594,1.594H1.594A1.594,1.594,0,0,1,0,45.281V35.719a1.594,1.594,0,0,1,1.594-1.594H4.516l.408-1.092A1.592,1.592,0,0,1,6.415,32h4.167a1.592,1.592,0,0,1,1.491,1.033l.412,1.092h2.922A1.594,1.594,0,0,1,17,35.719ZM12.484,40.5A3.984,3.984,0,1,0,8.5,44.484,3.988,3.988,0,0,0,12.484,40.5Zm-1.062,0A2.922,2.922,0,1,1,8.5,37.578,2.926,2.926,0,0,1,11.422,40.5Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0 -32)"
        />
    </svg>;

/* concierge bell icon */
export const ConciergeBellIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "17",
    height = "12.75",
    viewBox = "0 0 17 12.75",
    d = "M9.563,66.209v-.616h.531a.531.531,0,0,0,.531-.531v-.531A.531.531,0,0,0,10.094,64H6.906a.531.531,0,0,0-.531.531v.531a.531.531,0,0,0,.531.531h.531v.616a7.433,7.433,0,0,0-6.375,7.353H15.938A7.433,7.433,0,0,0,9.563,66.209Zm6.906,8.416H.531A.531.531,0,0,0,0,75.156v1.063a.531.531,0,0,0,.531.531H16.469A.531.531,0,0,0,17,76.219V75.156A.531.531,0,0,0,16.469,74.625Z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0 -64)"
        />
    </svg>;

/* glass martini icon */
export const GlassMartiniIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "12",
    height = "12",
    viewBox = "0 0 12 12",
    d = "M11.769,1.35A.791.791,0,0,0,11.21,0H.795A.791.791,0,0,0,.236,1.35L5.252,6.367v4.508H3.94A.938.938,0,0,0,3,11.813.187.187,0,0,0,3.19,12H8.815A.187.187,0,0,0,9,11.813a.938.938,0,0,0-.938-.938H6.752V6.367Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0 -0.002)"
        />
    </svg>;

/* skiing icon */
export const SkiingIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "17",
    height = "17",
    viewBox = "0 0 17 17",
    d = "M14.349,3.188a1.594,1.594,0,1,0-1.594-1.594A1.594,1.594,0,0,0,14.349,3.188Zm2.424,11.824a.794.794,0,0,0-1.126,0,1.351,1.351,0,0,1-1.5.289L9.64,12.97l1.634-2.451a1.594,1.594,0,0,0-.2-2.012L9.733,7.162,6.18,5.4a2.118,2.118,0,0,0,.588,1.806L9.262,9.7,7.738,11.987,1.167,8.59A.8.8,0,1,0,.436,10l13.013,6.724A2.924,2.924,0,0,0,14.681,17a2.956,2.956,0,0,0,2.092-.863A.8.8,0,0,0,16.773,15.012ZM3.989,3.042l-.382.747a1.3,1.3,0,0,0,1.421-.159L6.6,4.406s0,.007-.007.01l3.8,1.886,1.076-.432.213.634a1.581,1.581,0,0,0,.8.92l1.929.963a1.062,1.062,0,0,0,.95-1.9l-1.73-.867-.568-1.7a2.133,2.133,0,0,0-2.806-1.3L7.555,3.7,5.48,2.67a1.287,1.287,0,0,0-.694-1.182l-.369.721H4.411L3.268,1.976a.17.17,0,0,0-.166.056.174.174,0,0,0,.017.246l.87.764Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(-0.004)"
        />
    </svg>;

/* spa icon */
export const SpaIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "17",
    height = "13.222",
    viewBox = "0 0 17 13.222",
    d = "M16.771,36.717a9.439,9.439,0,0,0-6.311,2.45,7.584,7.584,0,0,0-1.96,2.8,7.584,7.584,0,0,0-1.96-2.8,9.439,9.439,0,0,0-6.311-2.45A.224.224,0,0,0,0,36.948,8.173,8.173,0,0,0,2.62,42.83,7.834,7.834,0,0,0,8.5,45.217a7.833,7.833,0,0,0,5.88-2.387A8.172,8.172,0,0,0,17,36.948.225.225,0,0,0,16.771,36.717ZM8.5,39.982a8.12,8.12,0,0,1,1.3-1.491,8.833,8.833,0,0,1,1.779-1.333,9.735,9.735,0,0,0-2.855-5.083.355.355,0,0,0-.447,0,9.735,9.735,0,0,0-2.855,5.078,8.677,8.677,0,0,1,1.748,1.31A8.346,8.346,0,0,1,8.5,39.982Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0, -31.995)"
        />
    </svg>;

/* shopping bag icon */
export const ShoppingBagIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "14",
    height = "16",
    viewBox = "0 0 14 16",
    d = "M11,5V4A4,4,0,1,0,3,4V5H0v8.5A2.5,2.5,0,0,0,2.5,16h9A2.5,2.5,0,0,0,14,13.5V5ZM5,4A2,2,0,1,1,9,4V5H5Zm5,3.75A.75.75,0,1,1,10.75,7,.75.75,0,0,1,10,7.75Zm-6,0A.75.75,0,1,1,4.75,7,.75.75,0,0,1,4,7.75Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
        />
    </svg>;

/* theater masks icon */
export const TheaterMasksIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "18",
    height = "14.4",
    viewBox = "0 0 18 14.4",
    d = "M5.816,6.895A2.1,2.1,0,0,0,4.2,8.979a3.34,3.34,0,0,1,1.4-.87l.215-1.214ZM2.692,8.3,1.8,3.248a.139.139,0,0,1,.007-.075A10.981,10.981,0,0,1,7.123,1.8c.045,0,.091,0,.136.005A2.7,2.7,0,0,1,8.71,1.069,13.677,13.677,0,0,1,10.318.92,1.807,1.807,0,0,0,9.143.16,12.761,12.761,0,0,0,.931,1.6a1.858,1.858,0,0,0-.9,1.955L.92,8.609c.4,2.265,3.834,4,5.75,4a2.589,2.589,0,0,0,.282-.022,7.552,7.552,0,0,1-1.111-1.9C4.5,10.316,2.857,9.23,2.692,8.3ZM5.436,4.431a1.111,1.111,0,0,0-.114-.321,1.772,1.772,0,0,1-.993.515,1.773,1.773,0,0,1-1.11-.145,1.106,1.106,0,0,0,0,.34,1.125,1.125,0,0,0,2.216-.39ZM17.064,3.4A12.749,12.749,0,0,0,8.852,1.956a1.862,1.862,0,0,0-1.52,1.529L6.44,8.534c-.433,2.448,2.68,5.52,4.452,5.832s5.751-1.513,6.184-3.961l.892-5.049a1.858,1.858,0,0,0-.9-1.955ZM9.379,6.123a1.125,1.125,0,0,1,2.216.39,1.111,1.111,0,0,1-.114.321,1.868,1.868,0,0,0-2.1-.37A1.1,1.1,0,0,1,9.379,6.123Zm1.982,5.59a3,3,0,0,1-2.5-3.175,4.631,4.631,0,0,0,2.8,1.513A4.639,4.639,0,0,0,14.8,9.583a3,3,0,0,1-3.442,2.13Zm3.665-4.256a1.868,1.868,0,0,0-2.1-.37,1.106,1.106,0,0,1,0-.34,1.125,1.125,0,0,1,2.216.39,1.1,1.1,0,0,1-.114.321Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0.002)"
        />
    </svg>;

/* bed icon */
export const BedIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "17",
    height = "10.2",
    viewBox = "0 0 17 10.2",
    d = "M4.675,69.1A2.125,2.125,0,1,0,2.55,66.975,2.127,2.127,0,0,0,4.675,69.1Zm9.35-3.4H8.075a.425.425,0,0,0-.425.425V69.95H1.7V64.425A.425.425,0,0,0,1.275,64H.425A.425.425,0,0,0,0,64.425v9.35a.425.425,0,0,0,.425.425h.85a.425.425,0,0,0,.425-.425V72.5H15.3v1.275a.425.425,0,0,0,.425.425h.85A.425.425,0,0,0,17,73.775v-5.1A2.975,2.975,0,0,0,14.025,65.7Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(0 -64)"
        />
    </svg>;


/* 
    icon save trip, 
    icon join to muvment
    landing page router arrow
*/
export const RightArrowIcon = ({
    style = {},
    fill = '#FFFFFF',
    className = '',
    width = "19",
    height = "19",
    viewBox = "0 0 448 512",
    d = "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
            transform="translate(-5 -4.675)"
        />
    </svg>;

export const LeftArrowIcon = ({
    style = {},
    fill = '#FFFFFF',
    className = '',
    width = "19",
    height = "19",
    viewBox = "0 0 448 512",
    d = "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d={d}
            fill={fill}
        />
    </svg>;

/* join to muvment with mail */
export const ConnectWithMailIcon = ({
    style = {},
    fill_envelope = '#FFFFFF',
    fill_circle = '#19BC9B',
    className = '',
    width = "90",
    height = "90",
    transform = "translate(0 -64)",
    viewBox = "0 0 90 90",
    d = "M40.177,64H4.156A4.156,4.156,0,0,0,0,68.156V93.094A4.156,4.156,0,0,0,4.156,97.25H40.177a4.156,4.156,0,0,0,4.156-4.156V68.156A4.156,4.156,0,0,0,40.177,64Zm0,4.156v3.533c-1.941,1.581-5.037,4.039-11.654,9.221-1.458,1.147-4.347,3.9-6.357,3.871-2.01.032-4.9-2.724-6.357-3.871C9.194,75.73,6.1,73.271,4.156,71.689V68.156ZM4.156,93.094V77.023c1.984,1.58,4.8,3.8,9.086,7.156,1.893,1.49,5.207,4.778,8.924,4.758,3.7.02,6.971-3.221,8.923-4.758,4.289-3.358,7.1-5.576,9.087-7.157V93.094Z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <g transform="translate(0)" >
                <ellipse cx="45" cy="45" rx="45" ry="45" transform="translate(0)" fill={fill_circle} />
            </g>

            <g transform="translate(23 -35)">
                <path
                    d={d}
                    fill={fill_envelope}
                    translate={transform}
                />
            </g>
        </g>
    </svg>;

/* join to muvment with facebook */
export const ConnectWithFacebookIcon = ({
    style = {},
    fill_envelope = '#FFFFFF',
    fill_circle = '#19BC9B',
    className = '',
    width = "90",
    height = "90",
    transform = "translate(-5.232 -1.247)",
    viewBox = "0 0 90 90",
    d = "M61.814,48.858H54.408V76.036H43.158V48.858H37.812V39.307h5.346V33.126A10.532,10.532,0,0,1,54.5,21.784l8.315.036v9.271H56.781a2.287,2.287,0,0,0-2.384,2.6v5.621h8.4Z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <g transform="translate(0)" >
                <ellipse cx="45" cy="45" rx="45" ry="45" transform="translate(0)" fill={fill_circle} />
            </g>

            <g transform="translate(-3 -3)">
                <path
                    d={d}
                    fill={fill_envelope}
                    translate={transform}
                />
            </g>
        </g>
    </svg>;

/* join to muvment with google */
export const ConnectWithGoogleIcon = ({
    style = {},
    fill_google = '#FFFFFF',
    fill_circle = '#19BC9B',
    className = '',
    width = "90",
    height = "90",
    transform = "translate(0 -8)",
    viewBox = "0 0 90 90",
    d = "M44,30.884c0,12.758-8.737,21.838-21.639,21.838A22.361,22.361,0,1,1,22.361,8a21.5,21.5,0,0,1,14.994,5.852L31.269,19.7C23.307,12.021,8.5,17.792,8.5,30.361A14.007,14.007,0,0,0,22.361,44.48c8.854,0,12.172-6.348,12.7-9.639h-12.7V27.151H43.648A19.6,19.6,0,0,1,44,30.884Z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <g transform="translate(0)" >
                <ellipse cx="45" cy="45" rx="45" ry="45" transform="translate(0)" fill={fill_circle} />
            </g>

            <g transform="translate(23 15)">
                <path
                    d={d}
                    fill={fill_google}
                    translate={transform}
                />
            </g>
        </g>
    </svg>;

/* join to muvment with instagram */
export const ConnectWithInstagramIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "90",
    height = "90",
    viewBox = "0 0 90 90",
    d1 = "M58.255,23.88H31.5a7.753,7.753,0,0,0-7.744,7.744V58.376A7.754,7.754,0,0,0,31.5,66.121H58.255A7.754,7.754,0,0,0,66,58.376V31.624A7.753,7.753,0,0,0,58.255,23.88ZM44.879,58.906A13.9,13.9,0,1,1,58.785,45,13.9,13.9,0,0,1,44.879,58.906ZM59.232,33.97a3.29,3.29,0,1,1,3.29-3.29,3.29,3.29,0,0,1-3.29,3.29Z",
    d2 = "M44.879,36.971A8.029,8.029,0,1,0,52.908,45a8.029,8.029,0,0,0-8.029-8.029Z",
    d3 = "M45,0A45,45,0,1,0,90,45,45,45,0,0,0,45,0ZM72.073,58.533A13.671,13.671,0,0,1,58.412,72.194H31.585A13.672,13.672,0,0,1,17.928,58.537V31.709A13.673,13.673,0,0,1,31.585,18.049H58.412A13.672,13.672,0,0,1,72.069,31.705Z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <g>
                <path
                    d={d1}
                    fill={fill}
                    translate={"translate(0.121 0.122)"}
                />
                <path
                    d={d2}
                    fill={fill}
                    translate={"translate(0.121 0.122)"}
                />
                <path
                    d={d3}
                    fill={fill}
                    translate={"translate(0)"}
                />
            </g>
        </g>
    </svg>;


/* check box landing page travel likes */
export const CheckedBoxReglarIcon = ({
    style = {},
    fill = '#FFFFFF00',
    stroke = '#19BC9B',
    strokeWidth = "2",
    className = '',
    width = "17",
    height = "17",
    transform = "translate(-1128 -825)",
    transform1 = "translate(1128 825)",
    viewBox = "0 0 17 17",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform={transform}>
            <g stroke={stroke} fill={fill} strokeWidth={strokeWidth} transform={transform1}>
                <rect width={width} height={height} stroke="none"></rect>
                <rect x={1} y={1} width={width - 2} height={height - 2} fill="none"></rect>
            </g>
            <g>
                <g>
                    <line y1="6" x2="7" transform="translate(1133.5 830.5)" fill="none" stroke={stroke} strokeWidth={strokeWidth}></line>
                    <line y1="2" x2="1" transform="translate(1132.5 833.5)" fill="none" stroke={stroke} strokeWidth={strokeWidth}></line>
                    <line y1="2" x2="1" transform="translate(1131.5 832.5)" fill="none" stroke={stroke} strokeWidth={strokeWidth}></line>
                </g>
            </g>
        </g>
    </svg>;

/* uncheck box landing page travel likes */
export const UnCheckBoxReglarIcon = ({
    style = {},
    fill = '#FFFFFF00',
    stroke = '#19BC9B',
    strokeWidth = "2",
    className = '',
    width = "17",
    height = "17",

    viewBox = "0 0 17 17",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g stroke={stroke} fill={fill} strokeWidth={strokeWidth}>
            <rect width={width} height={height} stroke="none"></rect>
            <rect x={1} y={1} width={width - 2} height={height - 2} fill="none"></rect>
        </g>
    </svg>;

/* disable check box landing page travel likes */
export const DisableCheckBoxReglarIcon = ({
    style = {},
    fill = '#FFFFFF00',
    stroke = '#E8E8E8',
    strokeWidth = "2",
    className = '',
    width = "17",
    height = "17",

    viewBox = "0 0 17 17",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g stroke={stroke} fill={fill} strokeWidth={strokeWidth}>
            <rect width={width} height={height} stroke="none"></rect>
            <rect x={1} y={1} width={width - 2} height={height - 2} fill="none"></rect>
        </g>
    </svg>;

/* langing likes image check box */
export const SunBeachIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "82.673",
    height = "82.673",
    percentageSize = 1,
    viewBox = "0 0 82.626 82.673",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-0.036)">
            <g transform="translate(0.032)">
                <path d="M36,18.023A11.023,11.023,0,1,0,47.023,7,11.023,11.023,0,0,0,36,18.023ZM47.023,9.756a8.267,8.267,0,1,1-8.267,8.267,8.267,8.267,0,0,1,8.267-8.267Z" transform="translate(13.561 2.645)" fill={fill}></path>
                <path transform="translate(16.206 9.825)" d="M43,27.378v2.756a1.378,1.378,0,1,0,2.756,0V27.378a1.378,1.378,0,1,0-2.756,0Z" fill={fill}></path>
                <path d="M45.756,4.134V1.378a1.378,1.378,0,1,0-2.756,0V4.134a1.378,1.378,0,1,0,2.756,0Z" transform="translate(16.206)" fill={fill}></path>
                <path d="M59.134,16.756a1.378,1.378,0,0,0,0-2.756H56.378a1.378,1.378,0,0,0,0,2.756Z" transform="translate(20.741 5.291)" fill={fill}></path>
                <path d="M30.378,16.756h2.756a1.378,1.378,0,0,0,0-2.756H30.378a1.378,1.378,0,1,0,0,2.756Z" transform="translate(10.915 5.291)" fill={fill}></path>
                <path d="M55.787,4.5a1.378,1.378,0,0,0-1.957,0L51.888,6.458A1.374,1.374,0,0,0,53.831,8.4l1.957-1.943a1.378,1.378,0,0,0,0-1.957Z" transform="translate(19.416 1.547)" fill={fill}></path>
                <path d="M33.5,26.812a1.378,1.378,0,0,0,1.957,0L37.4,24.855a1.378,1.378,0,1,0-1.943-1.943L33.5,24.855a1.378,1.378,0,0,0,0,1.957Z" transform="translate(12.463 8.476)" fill={fill}></path>
                <path d="M53.855,22.912a1.378,1.378,0,1,0-1.943,1.943c2.122,2.122,2.191,2.356,2.921,2.356a1.378,1.378,0,0,0,.978-2.356Z" transform="translate(19.392 8.476)" fill={fill}></path>
                <path d="M35.458,4.5A1.385,1.385,0,0,0,33.5,6.458C35.623,8.58,35.706,8.8,36.422,8.8A1.378,1.378,0,0,0,37.4,6.458Z" transform="translate(12.463 1.548)" fill={fill}></path>
                <path d="M78.528,54.968c-10.513,0-9.507,0-9.439-.1a4.836,4.836,0,0,0-.992-5.415l-9.5-9.49a6.889,6.889,0,0,0-9.756,0l-6.889,6.889a2.756,2.756,0,0,1-3.886,0L24.211,32.922A9.645,9.645,0,1,0,10.226,21.347a5.649,5.649,0,0,0-6.71.8,5.512,5.512,0,0,0,0,7.8l.51.5A5.512,5.512,0,0,0,1.6,39.591a1.384,1.384,0,1,0,1.957-1.957,2.748,2.748,0,1,1,3.886-3.886c25.2,25.174,23.645,23.7,24.044,23.865s-2.108.11,47.041.11A1.378,1.378,0,0,1,79.906,59.1v2.756a1.378,1.378,0,0,1-1.378,1.378H29.158c-8.846-8.86-7.758-7.73-7.854-7.868l-9.962-9.948A1.378,1.378,0,0,0,9.4,47.362l7.606,7.606h-6a5.512,5.512,0,1,0,0,11.024h2.756V72.88A4.134,4.134,0,0,0,17.9,77.014h1.378a4.134,4.134,0,0,0,4.134-4.134V65.991H64.749a6.889,6.889,0,1,0,11.023,0h2.756a4.134,4.134,0,0,0,4.134-4.134V59.1a4.134,4.134,0,0,0-4.134-4.132Zm-59.25-37.2a6.889,6.889,0,0,1,2.108,13.421,6.145,6.145,0,0,0-1.24-.22L12.54,23.363a6.889,6.889,0,0,1,6.739-5.6ZM5.5,27.975a2.756,2.756,0,0,1,0-3.886,2.825,2.825,0,0,1,3.913,0l.606.592c.11.138-.193-.152,8.571,8.584a1.378,1.378,0,0,0,1.033.386c1.833,0,2.425.965,3.459,2l-.4.262a1.378,1.378,0,0,0,.73,2.522c.5,0,.675-.179,1.612-.8l5.512,5.512a1.378,1.378,0,0,0,1.9,1.915l2,1.984L28.924,51.18C9.372,31.723,11.425,33.941,5.5,27.975ZM43.64,54.968H32.617l-1.764-1.777,5.594-4.2a5.512,5.512,0,0,0,7.523-.207l1.488-1.5L48.394,50.2Zm3.886,0,6.2-6.2,6.2,6.2Zm19.043-1.226a2.067,2.067,0,0,1-3.445.524L54.7,45.833a1.378,1.378,0,0,0-1.957,0l-2.411,2.425-2.921-2.935,3.39-3.376a4.134,4.134,0,0,1,5.842,0l9.48,9.494a2.012,2.012,0,0,1,.441,2.3ZM20.656,72.881a1.378,1.378,0,0,1-1.378,1.378H17.9a1.378,1.378,0,0,1-1.378-1.378v-6.89h4.134Zm-9.645-9.645a2.756,2.756,0,1,1,0-5.512h8.75l5.512,5.512Zm59.25,11.023A4.134,4.134,0,1,1,74.4,70.125a4.134,4.134,0,0,1-4.134,4.134Z" transform="translate(-0.032 5.659)" fill={fill}></path>
                <circle cx="1.378" cy="1.378" r="1.378" fill={fill} transform="translate(5.068 46.78)"></circle>
                <circle cx="1.378" cy="1.378" r="1.378" fill={fill} transform="translate(68.851 74.406)"></circle>
            </g>
        </g>
    </svg>;

export const OutdoorActivitiesIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "88.159",
    height = "71.049",
    percentageSize = 1,
    viewBox = "0 0 88.159 71.049",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(0 0.014)">
            <g transform="translate(0 -0.015)">
                <path fill={fill} d="M82.777,41.98a2.937,2.937,0,0,1-2.2-1,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,2.937,2.937,0,0,1-2.2,1,1.469,1.469,0,0,0,0,2.937,5.875,5.875,0,0,0,4.406-2,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,4.406,2,1.469,1.469,0,0,0,0-2.937Z" transform="translate(0.937 17.317)"></path>
                <path d="M16.687,48.92a5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,4.406,2,1.469,1.469,0,1,0,0-2.937,2.937,2.937,0,0,1-2.2-1,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,3.04,3.04,0,0,1-4.406,0,3.04,3.04,0,0,0-4.406,0,2.937,2.937,0,0,1-2.2,1,1.469,1.469,0,1,0,0,2.937,5.875,5.875,0,0,0,4.406-2,5.875,5.875,0,0,0,8.812,0Z" transform="translate(0.937 20.129)" fill={fill}></path>
                <path d="M0,30.469a1.469,1.469,0,0,0,1.469,1.469H5.875a1.469,1.469,0,0,0,0-2.937H1.469A1.469,1.469,0,0,0,0,30.469Z" transform="translate(0 12.145)" fill={fill}></path>
                <path d="M60.875,29H56.469a1.469,1.469,0,0,0,0,2.937h4.406a1.469,1.469,0,1,0,0-2.937Z" transform="translate(25.777 12.145)" fill={fill}></path>
                <path d="M9.931,23.037A7.343,7.343,0,0,0,5.6,35.477a1.469,1.469,0,0,0,2.438-1.2,1.234,1.234,0,0,0-.352-.852,4.406,4.406,0,0,1,5.7-6.682c.147.132-1.381-.984,8.357,5.978.969.69,1.806.543,3.525.543a4.406,4.406,0,0,0,8.107,2.174l2.937,2.937c-.661,1.146-.352,1.953,0,3.686H22.973A10.28,10.28,0,0,1,17,40.148,1.469,1.469,0,0,0,14.87,42.13H10.812a1.469,1.469,0,1,0,0,2.937h26.2c.338.749.235.529,4.259,4.553a2.5,2.5,0,0,0-.352.323,2.937,2.937,0,0,1-4.406,0,3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-4.406,0,3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-4.406,0,3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-4.406,0,3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-2.2,1,1.469,1.469,0,0,0,0,2.937,5.875,5.875,0,0,0,4.406-2,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,8.812,0c.352-.176.147-.308.411,0l.117.088a1.469,1.469,0,0,0,.587.911,5.875,5.875,0,0,0,7.7-1,5.875,5.875,0,0,0,8.812,0,5.875,5.875,0,0,0,7.857.867,4.054,4.054,0,0,0,2.438.338,5.875,5.875,0,0,0,7.343-1.2,5.875,5.875,0,0,0,4.391,2,1.469,1.469,0,0,0,0-2.937,2.937,2.937,0,0,1-2.2-1,3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-1.616.911c1.16-1.175,2.35-2.115,2.35-4.186a4.185,4.185,0,0,0-.5-1.982,1.469,1.469,0,0,0-.969-2.556H74.185l-1.072-1.072,6.58-4.714a7.343,7.343,0,1,0-8.533-11.93L62.8,30.38H58.735L62.1,20.5c1.307-3.921.147-6.727-2.086-8.21A7.343,7.343,0,1,0,49.57,14.313L43.446,17.6a1.469,1.469,0,0,0-2.321,1.733A4.406,4.406,0,0,0,44.592,26.4a5.038,5.038,0,0,0,2.658-.837L50.1,28.5l-.661,1.88h-14.2c3.6-10.574,3.907-10.971,3.907-13.218a5.875,5.875,0,0,0-2.629-4.876,7.343,7.343,0,1,0-10.442,2.027l-6.33,3.407a1.469,1.469,0,1,0-2.276,1.821,4.406,4.406,0,0,0,5.713,6.33l.367-.191,2.937,2.937-.543,1.762h-2.5l-8.357-5.963a7.343,7.343,0,0,0-5.155-1.381Zm39.8,24.674L47.66,49.782a1.469,1.469,0,0,1-2.086,0L39.7,43.907l-.808-3.98.969-.969c4.891.984,3.833.808,3.98.808,6.389,6.374,6.345,6.168,6.345,6.947a1.469,1.469,0,0,1-.454,1ZM62.95,49.943a3.025,3.025,0,0,0-4.406,0,2.937,2.937,0,0,1-4.406,0,2.937,2.937,0,0,0-1.733-.911,4.406,4.406,0,0,0,.4-3.965h7.946c.338.734,0,.338,5.361,5.654a2.937,2.937,0,0,1-3.162-.778Zm10.589-4.318a1.469,1.469,0,0,1,0,2.086l-2.086,2.071a1.469,1.469,0,0,1-2.027,0c-.5-.441-3.892-3.877-5.963-5.875l-.793-3.98.969-.969c4.891.984,3.833.808,3.98.808ZM64.507,32.774,72.864,26.8a4.406,4.406,0,1,1,5.126,7.167l-6.962,4.979c-2.35-2.335-1.469-1.806-6.8-2.937a2.937,2.937,0,0,0-2.027.338l-3.07-3.025c3.584,0,4.362.176,5.375-.543ZM49.424,8.35a4.406,4.406,0,1,1,4.406,4.406A4.406,4.406,0,0,1,49.424,8.35ZM45.282,23.287a1.47,1.47,0,0,1-1.4-2.585c10.883-5.875,9.047-5.008,9.943-5.008A7.344,7.344,0,0,0,57.9,14.46a2.937,2.937,0,0,1,1.805,2.7c0,1.66.1.984-5.17,16.464a1.469,1.469,0,0,1-2.849-.47c0-.382-.367.808,4.685-14.129a1.472,1.472,0,0,0-2.79-.94l-.294.9Zm4.656.822,2-1.072L51.171,25.3Zm-1.175,9.209a4.406,4.406,0,0,0,8.21,2l3.143,3.128c-.646,1.16-.338,1.953,0,3.686h-9.65c-4.861-4.861-4.861-5.067-5.992-5.287l-3.995-.808a2.82,2.82,0,0,0-2.012.338L35.339,33.32ZM25.925,8.35a4.406,4.406,0,1,1,4.406,4.406A4.406,4.406,0,0,1,25.925,8.35ZM21.783,23.287a1.47,1.47,0,0,1-1.4-2.585c10.883-5.875,9.047-5.008,9.943-5.008A7.343,7.343,0,0,0,34.4,14.46a2.937,2.937,0,0,1,1.806,2.7c0,1.66.117.984-5.17,16.464a1.469,1.469,0,0,1-2.849-.47c0-.382-.367.808,4.685-14.129a1.472,1.472,0,1,0-2.79-.94l-.294.9Zm4.406.94,2.247-1.19-.837,2.5Z" transform="translate(0.937 -0.985)" fill={fill}></path>
                <path d="M10.337,26.649a1.469,1.469,0,1,0-1.469,1.469A1.469,1.469,0,0,0,10.337,26.649Z" transform="translate(3.468 10.354)" fill={fill}></path>
            </g>
        </g>
    </svg>;

export const AdventureIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "83.651",
    height = "82.213",
    percentageSize = 1,
    viewBox = "0 0 83.651 82.213",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(0.001 0)">
            <circle cx="1.393" cy="1.393" cr="1.393" transform="translate(5.574 47.376)" fill={fill}></circle>
            <path d="M8.393,20.787H11.18a1.394,1.394,0,0,0,0-2.787H8.393a1.394,1.394,0,0,0,0,2.787Z" transform="translate(2.754 7.082)" fill={fill} ></path>
            <path d="M43,13.361A8.361,8.361,0,1,0,51.361,5,8.361,8.361,0,0,0,43,13.361Zm8.361-5.574a5.574,5.574,0,1,1-5.574,5.574,5.574,5.574,0,0,1,5.574-5.574Z" transform="translate(16.917 1.967)" fill={fill}></path>
            <path d="M50.787,2.661V1.393a1.393,1.393,0,1,0-2.787,0V2.661a1.393,1.393,0,1,0,2.787,0Z" transform="translate(18.884)" fill={fill}></path>
            <path d="M48,20.483v1.268a1.393,1.393,0,1,0,2.787,0V20.483a1.393,1.393,0,1,0-2.787,0Z" transform="translate(18.884 7.51)" fill={fill}></path>
            <path d="M59.751,10H58.483a1.394,1.394,0,1,0,0,2.787h1.268a1.393,1.393,0,0,0,0-2.787Z" transform="translate(22.46 3.934)" fill={fill}></path>
            <path d="M40.661,12.787a1.393,1.393,0,0,0,0-2.787H39.393a1.394,1.394,0,1,0,0,2.787Z" transform="translate(14.95 3.934)" fill={fill}></path>
            <path d="M57.707,3.336a1.393,1.393,0,0,0-1.979,0l-.892.892a1.393,1.393,0,0,0,.989,2.383c.7,0,.934-.348,1.881-1.3a1.393,1.393,0,0,0,0-1.979Z" transform="translate(21.412 1.15)" fill={fill}></path>
            <path d="M41.336,19.706a1.393,1.393,0,0,0,1.979,0l.892-.892a1.4,1.4,0,1,0-1.979-1.979l-.892.892a1.393,1.393,0,0,0,0,1.979Z" transform="translate(16.1 6.462)" fill={fill}></path>
            <path d="M56.814,16.836a1.4,1.4,0,0,0-1.979,1.979c.808.794,1.143,1.3,1.881,1.3a1.393,1.393,0,0,0,.989-2.383Z" transform="translate(21.412 6.462)" fill={fill}></path>
            <path d="M43.314,3.336a1.4,1.4,0,0,0-1.979,1.979c.808.794,1.143,1.3,1.881,1.3A1.393,1.393,0,0,0,44.2,4.232Z" transform="translate(16.101 1.151)" fill={fill}></path>
            <path d="M82.212,76.637c-17.195,0-16.122.111-16.637-.251l-8.361-5.95a4.18,4.18,0,0,0-2.369-.766H51.292c.348-.961.265-.78.265-7.636l7.58-13.265H71.845L81,64.793A1.4,1.4,0,1,0,83.424,63.4L67.9,36.228a2.787,2.787,0,0,0-4.835,0L51.557,56.419V33.288a4.835,4.835,0,0,0-3.484-8.207H37.622l-7.72-7.72a6.967,6.967,0,0,0-5.072-2.034,5.2,5.2,0,0,0-.223-.488,9.043,9.043,0,1,0-15.286-2.3H4.18A4.18,4.18,0,0,0,0,16.72V20.9a2.787,2.787,0,0,0,1.393,2.4V40.408a4.18,4.18,0,0,0,4.18,4.18H19.508a4.334,4.334,0,0,0,2.229-.669c1.393-.92-.39-.725,4.738-.725a6.967,6.967,0,0,1,6.967,6.967V62.7H26.308l-1.226-9.851A2.787,2.787,0,0,0,22.3,50.16H19.508a2.787,2.787,0,0,0-2.787,2.689l-1.31,19.6H8.361V54.342a1.394,1.394,0,1,0-2.787,0V79.424H1.393a1.394,1.394,0,0,0,0,2.787H19.619A4.18,4.18,0,0,0,22.8,80.817l6.688-7.8a1.393,1.393,0,0,1,1.059-.488c26.377,0,24.566-.125,25.082.251l8.361,5.95a4.18,4.18,0,0,0,2.425.766h15.8a1.394,1.394,0,0,0,0-2.787ZM65.491,37.621l4.765,8.361H60.725Zm-57.13,41.8v-4.18h8.361a2.787,2.787,0,0,1,2.787,2.787v1.393ZM22.212,77.15A5.574,5.574,0,0,0,18.2,72.68l1.31-19.731H22.3a.683.683,0,0,0,0,.167C23.925,66.4,23.688,62.7,23.688,69.67a2.787,2.787,0,0,0,2.564,2.787ZM35.588,27.059a2.787,2.787,0,0,0,2.034.808H43.2v4.18H36.4a4.738,4.738,0,0,1-3.6-1.853l2.634-3.288ZM20.9,40.408A1.393,1.393,0,0,1,19.508,41.8H5.574A1.393,1.393,0,0,1,4.18,40.408V32.661a5.448,5.448,0,0,0,2.787.78v2.787a1.393,1.393,0,1,0,2.787,0V33.441h5.574v2.787a1.393,1.393,0,1,0,2.787,0V33.441a5.448,5.448,0,0,0,2.787-.78Zm0-12.541a2.787,2.787,0,0,1-2.787,2.787H6.967A2.787,2.787,0,0,1,4.18,27.867v-4.18H20.9ZM2.787,20.9V16.72A1.393,1.393,0,0,1,4.18,15.327H20.9a1.393,1.393,0,0,1,1.393,1.393V20.9Zm19.787-8c-1.073-.488-.85-.362-10.116-.362a6.256,6.256,0,1,1,10.116.362ZM28.4,25.944a1.393,1.393,0,0,0-1.811.752c-.111.376-.111-.711-.111,13.711h-2.79V23.3a2.787,2.787,0,0,0,1.393-2.4V18.113a4.18,4.18,0,0,1,2.787,1.212L33.442,24.9l-2.634,3.288c-2.146-2.132-2.062-2.1-2.411-2.243ZM26.475,69.67V65.49h8.361a2.787,2.787,0,0,1,2.787,2.787V69.67Zm13.934,0V68.277a5.574,5.574,0,0,0-4.18-5.379V50.162a9.754,9.754,0,0,0-6.967-9.308v-10.2l2.2,2.216A6.967,6.967,0,0,0,36.4,34.834h6.8c0,36.591-.111,33.818.251,34.836Zm8.361-1.393a1.393,1.393,0,1,1-2.787,0V34.834a14.589,14.589,0,0,0,2.787-.084Zm-.892-36.229h-1.9v-4.18c2.257,0,2.884-.153,3.637.683a2.118,2.118,0,0,1-1.742,3.5Z" transform="translate(0 0.001)" fill={fill}></path>
        </g>
    </svg>;

export const ArtCultureIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "82.867",
    height = "82.868",
    percentageSize = 1,
    viewBox = "0 0 82.867 82.868",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <g transform="translate(-0.002)">
            <g transform="translate(0.002)">
                <path d="M81.655,80.44H80.188V76.291a1.214,1.214,0,0,0-1.214-1.214H77.507V46.67h.127a1.214,1.214,0,0,0,1.152-.83l1.341-4.022a1.214,1.214,0,0,0-1.152-1.6H77.507V20.486l2.326-2.326a1.214,1.214,0,0,0,.355-.858V11.939a1.214,1.214,0,0,0-1.214-1.214H77.507V7.79h1.467a1.214,1.214,0,0,0,1.214-1.214V1.214A1.214,1.214,0,0,0,78.974,0H17.047a1.214,1.214,0,0,0,0,2.428H77.76V5.362H5.111V2.428H12.2A1.214,1.214,0,0,0,12.2,0H3.9A1.214,1.214,0,0,0,2.683,1.214V6.576A1.214,1.214,0,0,0,3.9,7.79H5.364v2.935H3.9a1.214,1.214,0,0,0-1.214,1.214V17.3a1.214,1.214,0,0,0,.355.858l2.326,2.326V40.22H3.9a1.214,1.214,0,0,0-1.152,1.6l1.338,4.02a1.214,1.214,0,0,0,1.152.83h.127V75.077H3.9a1.214,1.214,0,0,0-1.214,1.214V80.44H1.216a1.214,1.214,0,0,0,0,2.428H81.655a1.214,1.214,0,0,0,0-2.428ZM72.142,7.79h2.936v2.935H72.142Zm-5.363,0h2.935v2.935H66.78Zm-5.363,0h2.935v2.935H61.417Zm-5.362,0h2.935v2.935H56.055Zm-5.363,0h2.935v2.935H50.692Zm-5.362,0h2.935v2.935H45.33Zm-5.363,0H42.9v2.935H39.967Zm-5.362,0h2.935v2.935H34.6Zm-5.363,0h2.935v2.935H29.242Zm-5.362,0h2.935v2.935H23.88Zm-5.363,0h2.935v2.935H18.517Zm-5.363,0h2.935v2.935H13.154Zm-5.362,0h2.935v2.935H7.792ZM5.111,16.8V13.153H77.758V16.8l-1.97,1.97H7.081ZM72.144,66.9V64.1h1.467a1.214,1.214,0,0,0,0-2.428H72.144V54.84a6.577,6.577,0,1,0-13.154,0v6.83H57.523a1.214,1.214,0,1,0,0,2.428H58.99V75.077H56.055V46.67H75.078V75.077H72.144v-8.17A.018.018,0,0,0,72.144,66.9ZM61.418,65.693V64.1h8.3v1.594Zm8.3,2.428v6.957h-8.3V68.12Zm-8.3-6.45V54.84a4.15,4.15,0,0,1,8.3,0v6.83ZM54.845,44.242h-.469l-.531-1.594H77.29l-.532,1.594Zm-9.514-16.9V21.2H75.079V40.22H56A14.654,14.654,0,0,0,45.331,27.341ZM42.9,21.2v5.616H39.968V21.2ZM25.347,61.671H23.88V54.84a6.576,6.576,0,1,0-13.153,0v6.83H9.259a1.214,1.214,0,0,0,0,2.428h1.468v2.8h0v8.166H7.792V46.67H26.815V75.077H23.88V64.1h1.467a1.214,1.214,0,1,0,0-2.428ZM13.154,65.693V64.1h8.3v1.594Zm8.3,2.428v6.957h-8.3V68.12Zm-8.3-6.45V54.84a4.15,4.15,0,0,1,8.3,0v6.83ZM6.581,44.242H6.113l-.531-1.594H29.026l-.532,1.594ZM26.866,40.22H7.792V21.2H37.54v6.144A14.654,14.654,0,0,0,26.866,40.22ZM29.5,80.44H5.111V77.5H29.5Zm21.451-4.149V80.44H31.924V76.291a1.214,1.214,0,0,0-1.214-1.214H29.243V46.67h.127a1.214,1.214,0,0,0,1.152-.83l1.341-4.022a1.214,1.214,0,0,0-1.152-1.6H29.3a12.192,12.192,0,0,1,24.264,0h-1.4a1.214,1.214,0,0,0-1.152,1.6L52.35,45.84a1.214,1.214,0,0,0,1.152.83h.127V75.077H52.161a1.214,1.214,0,0,0-1.214,1.214ZM77.76,80.44H53.375V77.5H77.76Z"
                    transform="translate(-0.002)" fill={fill} />
            </g>
            <g transform="translate(10.727 24.132)">
                <path fill={fill} d="M80.885,149.1H67.479a1.214,1.214,0,0,0-1.214,1.214V162.38a1.214,1.214,0,0,0,1.214,1.214h5.362a1.214,1.214,0,0,0,.777-.281l8.044-6.7a1.214,1.214,0,0,0,.437-.933v-5.363a1.213,1.213,0,0,0-1.214-1.217ZM72.4,161.165H68.693v-9.638H79.671v3.58h0Z"
                    transform="translate(-66.265 -149.099)" />
            </g>
            <g transform="translate(56.31 24.132)"><path fill={fill} d="M362.52,149.1H349.114a1.214,1.214,0,0,0-1.214,1.214v5.363a1.214,1.214,0,0,0,.437.933l8.044,6.7a1.215,1.215,0,0,0,.777.281h5.362a1.214,1.214,0,0,0,1.214-1.214V150.313a1.214,1.214,0,0,0-1.214-1.213Zm-1.214,12.066H357.6l-7.269-6.058v-3.58H361.31v9.638Z"
                transform="translate(-347.9 -149.099)" />
            </g>
            <g transform="translate(13.365 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
            <g transform="translate(24.091 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
            <g transform="translate(34.816 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
            <g transform="translate(45.54 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
            <g transform="translate(56.266 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
            <g transform="translate(66.992 14.705)">
                <circle fill={fill} cx="1.257" cy="1.257" r="1.257" transform="translate(0 0)" />
            </g>
        </g>
    </svg>

export const FoodNightlifeIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "69.052",
    height = "85.688",
    percentageSize = 1,
    viewBox = "0 0 69.052 85.688",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <g transform="translate(-49.7 0.001)">
            <g transform="translate(49.7)">
                <path
                    d="M118.687,28.583a1.255,1.255,0,0,0-1.191-.858H99.955l15.8-22.987a1.255,1.255,0,0,0-2.069-1.422L96.908,27.725H76.571a1.255,1.255,0,0,0,0,2.51H95.182l-4.946,7.194H64.313l-9.592-7.194H71.556a1.255,1.255,0,0,0,0-2.51H65.728A9.568,9.568,0,0,0,59.273,11.09h-.1L57.743,1.077a1.255,1.255,0,1,0-2.485.355l1.431,10.015a9.566,9.566,0,0,0-3.87,16.278H50.955a1.255,1.255,0,0,0-.753,2.259L82.971,54.561V75.4L69.717,83.355a1.255,1.255,0,0,0,.646,2.332H98.089a1.255,1.255,0,0,0,.646-2.332L85.481,75.4V54.561L118.25,29.984a1.255,1.255,0,0,0,.437-1.4ZM52.21,20.663a7.074,7.074,0,0,1,4.837-6.7l.983,6.879a1.256,1.256,0,0,0,1.241,1.078,1.273,1.273,0,0,0,.179-.013,1.255,1.255,0,0,0,1.065-1.42l-.983-6.879a7.062,7.062,0,0,1-.254,14.118h-.013a7.071,7.071,0,0,1-7.055-7.063ZM93.557,83.176H74.895l9.331-5.6ZM84.226,52.364,67.66,39.94H88.511l-5.319,7.737A1.255,1.255,0,0,0,85.26,49.1l6.3-9.16H100.8Zm19.913-14.935H93.283l4.946-7.194h15.5Z"
                    transform="translate(-49.7)"
                    fill={fill} />
            </g>
        </g>
    </svg >


export const LuxuryIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "80.596",
    height = "86.177",
    percentageSize = 1,
    viewBox = "0 0 80.596 86.177",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-16.566)">
            <g transform="translate(51.421 75.287)">
                <path fill={fill}
                    d="M224.913,447.3a1.262,1.262,0,0,0-1.262,1.262v1.394a1.262,1.262,0,1,0,2.525,0v-1.394a1.262,1.262,0,0,0-1.263-1.262Z"
                    transform="translate(-223.651 -447.3)" />
            </g>
            <g transform="translate(59.786 75.287)">
                <path fill={fill}
                    d="M274.611,447.3a1.262,1.262,0,0,0-1.262,1.262v1.394a1.262,1.262,0,1,0,2.525,0v-1.394a1.262,1.262,0,0,0-1.263-1.262Z"
                    transform="translate(-273.349 -447.3)" />
            </g>
            <g transform="translate(52.815 3.486)">
                <path fill={fill}
                    d="M238.771,20.709a1.262,1.262,0,0,0-1.262,1.262v2.223h-3.052V21.971a1.262,1.262,0,1,0-2.525,0v6.972a1.263,1.263,0,0,0,2.525,0V26.719h3.052v2.223a1.263,1.263,0,0,0,2.525,0V21.971a1.262,1.262,0,0,0-1.263-1.262Z"
                    transform="translate(-231.932 -20.709)" />
            </g>
            <g transform="translate(16.566)">
                <path fill={fill}
                    d="M95.9,41.826H80.436V20.781a1.262,1.262,0,0,0-1.262-1.262h-.132V16.467h1.526A1.262,1.262,0,0,0,81.83,15.2V9.627a1.262,1.262,0,0,0-1.262-1.262H65.1v-7.1A1.262,1.262,0,0,0,63.837,0H49.9a1.262,1.262,0,0,0-1.262,1.262v7.1H33.165A1.262,1.262,0,0,0,31.9,9.627V15.2a1.262,1.262,0,0,0,1.262,1.262h1.526v3.052h-.132A1.262,1.262,0,0,0,33.3,20.781V31.935a1.263,1.263,0,1,0,2.525,0V22.043h42.09V43.085h0V70.969h0V83.653h-4.45V80.6h.829a1.262,1.262,0,0,0,1.262-1.262V70.973a1.262,1.262,0,0,0-1.262-1.262H70.111a1.262,1.262,0,0,0-1.262,1.262v8.365A1.262,1.262,0,0,0,70.111,80.6h.829v3.053H66.494V69.447H68.02a1.262,1.262,0,0,0,1.262-1.262V62.608a1.262,1.262,0,0,0-1.262-1.262H45.713a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h1.526V83.653H42.792V80.6h.829a1.262,1.262,0,0,0,1.262-1.262V70.973a1.262,1.262,0,0,0-1.262-1.262H39.439a1.262,1.262,0,0,0-1.262,1.262v8.365A1.262,1.262,0,0,0,39.439,80.6h.829v3.053H35.821V36.979a1.263,1.263,0,0,0-2.525,0v4.847H17.828a1.262,1.262,0,0,0-1.262,1.262V70.973a1.262,1.262,0,0,0,1.262,1.262h1.526v12.68a1.262,1.262,0,0,0,1.262,1.262h72.5a1.262,1.262,0,0,0,1.262-1.262V72.235H95.9a1.262,1.262,0,0,0,1.262-1.262V43.088A1.262,1.262,0,0,0,95.9,41.826ZM33.3,83.653H21.879V72.235H33.3Zm0-13.942H19.091V44.351H33.3Zm9.062,8.365H40.7v-5.84h1.658Zm13.2,5.578h-5.8V69.447h5.8Zm8.409,0H58.085V69.447h5.884ZM48.5,66.922H46.975V63.87H66.757v3.052ZM73.03,78.075H71.373v-5.84h1.658ZM51.157,2.525H62.575v7.1h0v4.311H51.157Zm-15.2,11.417h-1.53V10.89H48.633v3.052H35.953Zm40.564,5.577h-39.3V16.467h39.3Zm1.269-5.577H65.1V10.89H79.305v3.052ZM91.853,83.653H80.436V72.235H91.853ZM94.641,69.71H80.436V44.351H94.641Z"
                    transform="translate(-16.566)" />
            </g>
            <g transform="translate(22.143 47.403)">
                <path fill={fill}
                    d="M56.538,281.632H50.961a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,56.538,281.632Zm-1.262,5.577H52.224v-3.052h3.052Z"
                    transform="translate(-49.699 -281.632)" />
            </g>
            <g transform="translate(38.873 47.403)">
                <path fill={fill}
                    d="M155.938,281.632h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,155.938,281.632Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-149.099 -281.632)" />
            </g>
            <g transform="translate(66.757 47.403)">
                <path fill={fill}
                    d="M321.605,281.632h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577h0a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,321.605,281.632Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-314.766 -281.632)" />
            </g>
            <g transform="translate(52.772 47.403)">
                <path fill={fill}
                    d="M238.514,281.632h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,238.514,281.632Zm-1.262,5.577H234.2v-3.052h3.052Z"
                    transform="translate(-231.675 -281.632)" />
            </g>
            <g transform="translate(38.873 36.249)">
                <path fill={fill}
                    d="M155.938,215.365h-5.577a1.262,1.262,0,0,0-1.262,1.262V222.2a1.262,1.262,0,0,0,1.262,1.262h5.577A1.262,1.262,0,0,0,157.2,222.2v-5.577A1.262,1.262,0,0,0,155.938,215.365Zm-1.262,5.577h-3.052V217.89h3.052Z"
                    transform="translate(-149.099 -215.365)" />
            </g>
            <g transform="translate(66.757 36.249)">
                <path fill={fill}
                    d="M321.605,215.365h-5.577a1.262,1.262,0,0,0-1.262,1.262V222.2h0a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,321.605,215.365Zm-1.262,5.577h-3.052V217.89h3.052Z"
                    transform="translate(-314.766 -215.365)" />
            </g>
            <g transform="translate(52.772 36.249)">
                <path fill={fill} d="M238.514,215.365h-5.577a1.262,1.262,0,0,0-1.262,1.262V222.2a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,238.514,215.365Zm-1.262,5.577H234.2V217.89h3.052Z"
                    transform="translate(-231.675 -215.365)" />
            </g>
            <g transform="translate(38.873 25.095)">
                <path fill={fill}
                    d="M155.938,149.1h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,155.938,149.1Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-149.099 -149.097)" />
            </g>
            <g transform="translate(66.757 25.095)">
                <path fill={fill}
                    d="M321.606,149.1h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,321.606,149.1Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-314.767 -149.097)" />
            </g>
            <g transform="translate(52.772 25.095)">
                <path fill={fill}
                    d="M238.514,149.1h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,238.514,149.1Zm-1.262,5.577H234.2v-3.052h3.052Z"
                    transform="translate(-231.675 -149.097)" />
            </g>
            <g transform="translate(83.488 47.403)">
                <path fill={fill}
                    d="M421.006,281.632h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577a1.262,1.262,0,0,0,1.262,1.262h5.577a1.262,1.262,0,0,0,1.262-1.262v-5.577A1.262,1.262,0,0,0,421.006,281.632Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-414.167 -281.632)" />
            </g>
            <g transform="translate(22.143 58.557)">
                <path fill={fill}
                    d="M56.538,347.9H50.961a1.262,1.262,0,0,0-1.261,1.26v5.577A1.262,1.262,0,0,0,50.961,356h5.577a1.262,1.262,0,0,0,1.262-1.262V349.16A1.262,1.262,0,0,0,56.538,347.9Zm-1.262,5.577H52.224v-3.052h3.052Z"
                    transform="translate(-49.699 -347.898)" />
            </g>
            <g transform="translate(83.488 58.557)">
                <path fill={fill}
                    d="M421.006,347.9h-5.577a1.262,1.262,0,0,0-1.262,1.262v5.577A1.262,1.262,0,0,0,415.429,356h5.577a1.262,1.262,0,0,0,1.262-1.262V349.16A1.262,1.262,0,0,0,421.006,347.9Zm-1.262,5.577h-3.052v-3.052h3.052Z"
                    transform="translate(-414.167 -347.898)" />
            </g>
        </g>
    </svg>

export const HealthWellnessIcon = ({
    style = {},
    fill = "#FFFFFF00",
    stroke = '#19BC9B',
    strokeWidth = '2px',
    className = '',
    width = "75.381",
    height = "49.075",
    percentageSize = 1,
    viewBox = "0 0 75.381 49.075",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(0.933 -86.769)"><path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d="M322.2,265.552a30.281,30.281,0,0,1-2.2,4.759,38.954,38.954,0,0,1-17.637,15.009,31.545,31.545,0,0,0,4,.278,23.29,23.29,0,0,0,9.049-1.7c10.1-4.254,14.705-16.217,14.705-16.217a35.814,35.814,0,0,0-7.918-2.131Z" transform="translate(-256.957 -150.756)" /><path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d="M10.115,270.294a30.33,30.33,0,0,1-2.2-4.741A35.812,35.812,0,0,0,0,267.676s4.6,11.963,14.705,16.217a23.283,23.283,0,0,0,9.049,1.7,31.53,31.53,0,0,0,4-.278,38.946,38.946,0,0,1-17.641-15.02Z" transform="translate(0 -150.757)" /><path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d="M308.184,139.9a31.8,31.8,0,0,0,12.359-11.432c6.75-11.659,2.394-26.8,2.394-26.8a45.075,45.075,0,0,0-12.684,5.813,32.334,32.334,0,0,1,3.661,14.372,34.557,34.557,0,0,1-5.729,18.051Z" transform="translate(-261.902 -11.483)" /><path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d="M87.665,139.9a34.554,34.554,0,0,1-5.729-18.047A32.335,32.335,0,0,1,85.6,107.478a45.076,45.076,0,0,0-12.684-5.813s-4.356,15.144,2.394,26.8A31.8,31.8,0,0,0,87.665,139.9Z" transform="translate(-60.784 -11.48)" /><path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d="M185.064,88.157s-10.341,9.946-10.341,22.217,10.341,22.213,10.341,22.213,10.341-9.946,10.341-22.213S185.064,88.157,185.064,88.157Z" transform="translate(-148.482 0)" /></g></svg>

export const SightseeingIcon = ({
    style = {},
    fill = "#19BC9B",
    className = '',
    width = "71.021",
    height = "88.13",
    viewBox = "0 0 71.021 88.13",
    percentageSize = 1,
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-0.003)">
            <g>
                <path d="M120.706,58.135a.085.085,0,0,0,0-.035,1.256,1.256,0,0,0-.044-.18v-.006l-2.785-8.356V23.041a1.291,1.291,0,0,0-2.582,0V48.477H97.908V36.782a16.975,16.975,0,1,0-25.4,0v11.7H55.135V6.994a4.417,4.417,0,0,1,4.412-4.412h51.329a4.417,4.417,0,0,1,4.412,4.412V17.882a1.291,1.291,0,0,0,2.582,0V6.994A7,7,0,0,0,110.875,0H59.547a7,7,0,0,0-6.994,6.994V49.558l-2.785,8.356v.006a1.307,1.307,0,0,0-.044.18.085.085,0,0,1-.005.035,1.29,1.29,0,0,0-.015.187V69.728a7,7,0,0,0,7,7h8.689V86.839A1.291,1.291,0,0,0,66.68,88.13h37.071a1.291,1.291,0,0,0,1.291-1.291V76.723h8.689a7,7,0,0,0,6.994-6.994V58.322a1.241,1.241,0,0,0-.019-.187Zm-5.058-7.077,1.991,5.973H97.908V51.059ZM70.819,25.529A14.393,14.393,0,1,1,85.212,39.922,14.393,14.393,0,0,1,70.819,25.529ZM89.354,48.477V41.992a16.918,16.918,0,0,0,5.973-2.839v9.324Zm5.972,2.582v5.973H89.354V51.059ZM83.651,48.477V42.431c.514.047,1.034.072,1.561.072s1.046-.025,1.561-.072v6.045Zm3.121,2.582v5.973H83.651V51.059ZM75.1,48.477V39.152a16.917,16.917,0,0,0,5.973,2.84v6.485Zm5.973,2.582v5.973H75.1V51.059Zm-26.294,0h17.74v5.973H52.783ZM102.456,75.43V85.548H67.967V68.168h1.7V82.561a1.291,1.291,0,0,0,1.291,1.291H99.469a1.291,1.291,0,0,0,1.291-1.291V68.168h1.7ZM72.244,81.27V68.17H98.178v13.1Zm45.9-11.542a4.417,4.417,0,0,1-4.412,4.412h-8.689V68.168H106.6a1.291,1.291,0,1,0,0-2.582H63.824a1.291,1.291,0,0,0,0,2.582h1.561V74.14H56.7a4.417,4.417,0,0,1-4.412-4.412V59.613h65.856Z" transform="translate(-49.701)" fill={fill} />
            </g>
        </g>
        <g transform="translate(11.403 5.703)">
            <g>
                <path d="M124.387,33.134h-7.129a1.291,1.291,0,0,0-1.291,1.291v7.129a1.291,1.291,0,0,0,1.291,1.291h7.129a1.291,1.291,0,0,0,1.291-1.291V34.425A1.291,1.291,0,0,0,124.387,33.134ZM123.1,40.263h-4.547V35.716H123.1Z" transform="translate(-115.967 -33.134)" fill={fill} />
            </g>
        </g>
        <g transform="translate(51.326 37.071)">
            <path d="M352.045,215.368a4.142,4.142,0,1,0,4.142,4.142,4.142,4.142,0,0,0-4.142-4.142Zm0,5.7a1.561,1.561,0,1,1,1.561-1.561,1.561,1.561,0,0,1-1.561,1.561Z" transform="translate(-347.903 -215.368)" fill={fill} />
        </g>
        <g transform="translate(22.81 12.832)">
            <path d="M194.934,74.551a12.7,12.7,0,1,0,12.7,12.7A12.7,12.7,0,0,0,194.934,74.551Zm0,22.812a10.115,10.115,0,1,1,10.115-10.115,10.115,10.115,0,0,1-10.115,10.115Z" transform="translate(-182.237 -74.551)" fill={fill} />
        </g>
    </svg>

export const BudgetTravelIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "100",
    height = "57.965",
    percentageSize = 1,
    viewBox = "0 0 100 57.965",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(0 -107.61)">
            <g transform="translate(0 107.61)">
                <path fill={fill} d="M98.535,127H74.115v-17.92a1.465,1.465,0,0,0-1.465-1.465H1.465A1.465,1.465,0,0,0,0,109.075v35.65a1.465,1.465,0,0,0,1.465,1.465h24.42v17.92a1.465,1.465,0,0,0,1.465,1.465H98.535A1.465,1.465,0,0,0,100,164.11V128.46A1.465,1.465,0,0,0,98.535,127ZM25.885,143.26H2.93V110.54H71.185V127H69.261v-6.537a1.465,1.465,0,0,0-1.465-1.465,5.012,5.012,0,0,1-5.007-5.007,1.465,1.465,0,0,0-1.465-1.465H12.79a1.465,1.465,0,0,0-1.465,1.465,5.012,5.012,0,0,1-5.007,5.007,1.465,1.465,0,0,0-1.465,1.465V133.4a1.465,1.465,0,0,0,1.465,1.465,5.012,5.012,0,0,1,5.007,5.007,1.465,1.465,0,0,0,1.465,1.465h13.1v1.923Zm1.465-16.265a1.465,1.465,0,0,0-1.465,1.465v9.948H14.12a7.959,7.959,0,0,0-6.336-6.336V121.788a7.958,7.958,0,0,0,6.336-6.336H60a7.958,7.958,0,0,0,6.336,6.336V127H59.551v-.065a4.7,4.7,0,0,0-9.4,0c0,.022,0,.044,0,.065H46.609v-.065a9.554,9.554,0,1,0-19.108,0c0,.022,0,.044,0,.065Zm29.277,0H53.079v-.065a1.771,1.771,0,0,1,3.542,0c0,.022.006.043.007.065Zm-12.943,0H30.43v-.065a6.625,6.625,0,0,1,13.249,0c0,.022,0,.043.006.065Zm53.385,35.65H28.815V144.729h0v-14.8H67.507a1.458,1.458,0,0,0,.578,0H72.36a1.458,1.458,0,0,0,.578,0H97.07Z"
                    transform="translate(0 -107.61)" />
            </g>
            <g transform="translate(30.739 131.907)">
                <path fill={fill}
                    d="M220.328,238.483a5.012,5.012,0,0,1-5.006-5.006,1.465,1.465,0,0,0-1.465-1.465H165.321a1.465,1.465,0,0,0-1.465,1.465,5.012,5.012,0,0,1-5.007,5.006,1.465,1.465,0,0,0-1.465,1.465v12.943a1.465,1.465,0,0,0,1.465,1.465,5.012,5.012,0,0,1,5.007,5.007,1.465,1.465,0,0,0,1.465,1.465h48.535a1.465,1.465,0,0,0,1.465-1.465,5.012,5.012,0,0,1,5.006-5.007,1.465,1.465,0,0,0,1.465-1.465V239.948a1.465,1.465,0,0,0-1.464-1.465Zm-1.465,13.078a7.958,7.958,0,0,0-6.336,6.336H166.651a7.959,7.959,0,0,0-6.336-6.336V241.277a7.958,7.958,0,0,0,6.336-6.336h45.876a7.958,7.958,0,0,0,6.336,6.336Z"
                    transform="translate(-157.385 -232.012)" />
            </g>
            <g transform="translate(53.389 136.761)">
                <path fill={fill}
                    d="M282.906,256.861a9.554,9.554,0,1,0,9.554,9.554A9.554,9.554,0,0,0,282.906,256.861Zm0,16.178a6.624,6.624,0,1,1,6.624-6.624,6.624,6.624,0,0,1-6.624,6.624Z"
                    transform="translate(-273.352 -256.861)" />
            </g>
            <g transform="translate(40.446 141.614)">
                <path fill={fill} d="M211.785,281.711a4.7,4.7,0,1,0,4.7,4.7,4.7,4.7,0,0,0-4.7-4.7Zm0,6.471a1.771,1.771,0,1,1,1.771-1.771,1.771,1.771,0,0,1-1.771,1.771Z"
                    transform="translate(-207.085 -281.711)" />
            </g>
            <g transform="translate(76.039 141.614)">
                <path fill={fill}
                    d="M394.018,281.711a4.7,4.7,0,1,0,4.7,4.7,4.7,4.7,0,0,0-4.7-4.7Zm0,6.471a1.771,1.771,0,1,1,1.771-1.771,1.771,1.771,0,0,1-1.771,1.771Z"
                    transform="translate(-389.318 -281.711)" />
            </g>
            <g transform="translate(14.561 122.229)">
                <path fill={fill}
                    d="M79.252,182.461a4.7,4.7,0,1,0,4.7,4.7A4.7,4.7,0,0,0,79.252,182.461Zm0,6.471a1.771,1.771,0,1,1,1.771-1.771,1.771,1.771,0,0,1-1.771,1.771Z"
                    transform="translate(-74.551 -182.461)" />
            </g>
            <g transform="translate(77.657 109.242)">
                <path fill={fill}
                    d="M413.046,126.1a1.465,1.465,0,0,0-2.072,0l-.743.743a11.183,11.183,0,0,0-11.164-10.879,1.465,1.465,0,1,0,0,2.93,8.251,8.251,0,0,1,8.234,7.934l-.728-.728a1.465,1.465,0,1,0-2.071,2.072l3.235,3.234a1.441,1.441,0,0,0,.109.1l.046.034c.016.012.046.035.07.051s.039.024.059.036.042.026.064.038l.063.03c.022.011.044.022.067.031l.063.023c.024.009.048.018.073.025l.064.016c.025.006.05.013.075.018s.05.008.075.012l.066.01c.048,0,.1.007.144.007a1.012,1.012,0,0,0,.145-.007.377.377,0,0,0,.066-.01c.022,0,.05-.006.075-.012l.075-.018.063-.016.073-.025.063-.023c.023-.009.045-.021.067-.031s.042-.019.063-.03.043-.025.064-.038.04-.023.059-.036l.07-.051.046-.034a1.453,1.453,0,0,0,.109-.1l3.235-3.234a1.465,1.465,0,0,0,0-2.072Z"
                    transform="translate(-397.602 -115.968)" />
            </g>
            <g transform="translate(3.236 148.07)">
                <path fill={fill}
                    d="M30.976,327.706a8.251,8.251,0,0,1-8.234-7.934l.728.727a1.465,1.465,0,1,0,2.071-2.072l-3.235-3.234a1.408,1.408,0,0,0-.109-.1l-.046-.034c-.015-.011-.046-.035-.069-.051s-.039-.024-.059-.036-.042-.026-.064-.038-.041-.02-.061-.029l-.069-.032-.06-.022c-.025-.009-.05-.019-.076-.027l-.059-.015-.08-.02-.065-.01c-.026,0-.051-.009-.077-.011s-.072,0-.109-.005h-.07a.8.8,0,0,0-.109.005l-.077.011-.065.01c-.027.005-.054.013-.08.02l-.059.015-.076.026-.06.022-.069.032c-.023.011-.041.019-.061.03l-.064.038c-.021.013-.04.023-.059.036s-.046.034-.069.051l-.046.034a1.4,1.4,0,0,0-.109.1L17,318.427a1.465,1.465,0,1,0,2.071,2.072l.743-.743a11.183,11.183,0,0,0,11.164,10.879,1.465,1.465,0,1,0,0-2.93Z"
                    transform="translate(-16.568 -314.763)" />
            </g>
        </g>
    </svg>

export const MountainIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "80.658",
    height = "80.728",
    percentageSize = 1,
    viewBox = "0 0 80.658 80.728",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-0.037)">
            <g transform="translate(0.003 18.284)">
                <path fill={fill}
                    d="M79.547,176.044h-1.9L56.8,136.344v-.009l-6.247-11.9a1.183,1.183,0,0,0-2.094,0l-4.1,7.818L36.19,116.6a1.182,1.182,0,0,0-2.1,0L23.8,136.333l-.006.011L3.08,176.044H1.186a1.183,1.183,0,0,0,0,2.365H11.743a1.183,1.183,0,0,0,0-2.365H5.748l19.4-37.18,5.242,5.242a1.183,1.183,0,0,0,1.673,0l5.693-5.694,3.082,3.082a1.182,1.182,0,0,0,1.672,0l2.63-2.63.1.2v.009L51.8,151.654a1.184,1.184,0,1,0,2.1-1.094l-6.166-11.818.329-.329,3.082,3.082a1.182,1.182,0,0,0,1.672,0l2.633-2.633,19.521,37.183H57.221v-2.86h4.042a1.182,1.182,0,0,0,1.1-1.622L60.4,166.655h.866a1.182,1.182,0,0,0,1.081-1.663l-5.224-11.754a1.183,1.183,0,0,0-2.161,0l-5.224,11.754a1.182,1.182,0,0,0,1.081,1.663h.865l-1.963,4.908a1.182,1.182,0,0,0,1.1,1.622h4.042v2.86H25.876v-2.86h4.042a1.182,1.182,0,0,0,1.1-1.622l-1.964-4.908h.866A1.182,1.182,0,0,0,31,164.992l-5.224-11.754a1.183,1.183,0,0,0-2.161,0l-5.224,11.754a1.182,1.182,0,0,0,1.081,1.663h.865l-1.963,4.908a1.182,1.182,0,0,0,1.1,1.622h4.042v2.86H16.468a1.183,1.183,0,0,0,0,2.365H79.547a1.183,1.183,0,0,0,0-2.365ZM41.672,138.985,38.59,135.9a1.182,1.182,0,0,0-1.672,0l-5.694,5.7-4.931-4.931,8.849-16.961,8.849,16.961Zm10.316,0L48.906,135.9a1.182,1.182,0,0,0-1.672,0l-.639.64-.1-.2-.006-.011-.8-1.528,3.82-7.277,4.8,9.139ZM21.217,170.819l1.963-4.908a1.183,1.183,0,0,0-1.1-1.622h-.79l3.4-7.66,3.4,7.66H27.3a1.182,1.182,0,0,0-1.1,1.622l1.964,4.908Zm31.345,0,1.963-4.908a1.183,1.183,0,0,0-1.1-1.622h-.792l3.4-7.66,3.4,7.66H58.64a1.182,1.182,0,0,0-1.1,1.622l1.964,4.908Z"
                    transform="translate(-0.003 -115.966)" />
            </g>
            <g transform="translate(39.184)">
                <path fill={fill}
                    d="M256.213,0a7.713,7.713,0,1,0,7.713,7.713A7.713,7.713,0,0,0,256.213,0Zm0,13.061a5.348,5.348,0,1,1,5.348-5.348,5.348,5.348,0,0,1-5.348,5.348Z"
                    transform="translate(-248.5)" />
            </g>
            <g transform="translate(2.615 7.836)">
                <path fill={fill}
                    d="M46.485,56.23H42.332a6.408,6.408,0,0,0-9.04-4.608A7.711,7.711,0,0,0,20.578,56.23H17.753a1.183,1.183,0,0,0,0,2.365h7.836a1.183,1.183,0,0,0,0-2.365h-2.6a5.346,5.346,0,0,1,9.225-2.354,1.183,1.183,0,0,0,1.553.194A4.042,4.042,0,0,1,39.9,56.23H38.649a1.183,1.183,0,0,0,0,2.365h7.836a1.183,1.183,0,0,0,0-2.365Z"
                    transform="translate(-16.57 -49.7)" />
            </g>
            <g transform="translate(48.326 13.061)">
                <path fill={fill}
                    d="M336.4,89.365h-4.152a6.408,6.408,0,0,0-9.04-4.608,7.711,7.711,0,0,0-12.715,4.608h-2.826a1.183,1.183,0,0,0,0,2.365H315.5a1.183,1.183,0,0,0,0-2.365h-2.6a5.345,5.345,0,0,1,9.224-2.353,1.183,1.183,0,0,0,1.553.194,4.042,4.042,0,0,1,6.138,2.159h-1.253a1.183,1.183,0,0,0,0,2.365H336.4a1.183,1.183,0,1,0,0-2.365Z"
                    transform="translate(-306.485 -82.835)" />
            </g>
        </g>
    </svg>


/* calendar duotone icon on menu */
export const ShoppingTripsIcon = ({
    style = {
        display: "inline-block",
        fontSize: "inherit",
    },
    percentageSize = 1,
    className = '',
    fill = '#19BC9B',
    width = "72",
    height = '73',
    viewBox = '0 0 448 512',
    d = "M352 128C352 57.421 294.579 0 224 0 153.42 0 96 57.421 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 32c52.935 0 96 43.065 96 96H128c0-52.935 43.065-96 96-96zm192 400c0 26.467-21.533 48-48 48H80c-26.467 0-48-21.533-48-48V160h64v48c0 8.837 7.164 16 16 16s16-7.163 16-16v-48h192v48c0 8.837 7.163 16 16 16s16-7.163 16-16v-48h64v272z",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g>
            <path
                d={d}
                fill={fill}
            />
        </g>
    </svg>;

export const RoadTripIcon = ({
    style = {},
    fill = '#19BC9B',
    className = '',
    width = "85.812",
    height = "74.7",
    percentageSize = 1,
    viewBox = "0 0 85.812 74.7",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <g transform="translate(0 -33.14)">
            <g transform="translate(67.34 44.823)">
                <path
                    fill={fill}
                    d="M405.081,102.875a3.34,3.34,0,1,0,3.34,3.34,3.34,3.34,0,0,0-3.34-3.34Zm0,4.165a.825.825,0,1,1,.826-.825.825.825,0,0,1-.826.825Z"
                    transform="translate(-401.741 -102.875)" />
            </g>
            <g transform="translate(0 33.133)">
                <path fill={fill}
                    d="M84.811,38.711,57.049,33.158h-.018a1.252,1.252,0,0,0-.145-.018h-.212a1.256,1.256,0,0,0-.158.026l-.035.009a1.219,1.219,0,0,0-.136.043l-.016.005L28.906,44.192l-14.048-2.81a1.257,1.257,0,0,0-.493,2.466l13.4,2.681V66.067L16.506,63.815h-.025a6.812,6.812,0,1,0-2.666,13.36h0l13.951,2.79v9.4l-7.3-1.46,1.116-1.116A1.257,1.257,0,0,0,19.8,85.011L17.919,86.9l-1.888-1.888a1.257,1.257,0,0,0-1.778,1.778l1.888,1.888-1.888,1.888a1.257,1.257,0,0,0,1.778,1.778l1.888-1.888,1.888,1.888a1.257,1.257,0,0,0,1.907-1.625L27.77,91.93v13.129L2.514,100V41.477l6.827,1.365a1.257,1.257,0,1,0,.493-2.466L1.5,38.711A1.257,1.257,0,0,0,0,39.944v61.091a1.257,1.257,0,0,0,1.011,1.233l27.758,5.552h.037c.031,0,.062.011.093.014s.084.006.125.006a.845.845,0,0,0,.123-.006l.064-.009.056-.009c.025,0,.05-.012.075-.018l.042-.011.075-.026.033-.011.02-.008h0l27.4-10.96,27.4,5.48a1.257,1.257,0,0,0,1.5-1.233V39.944A1.257,1.257,0,0,0,84.811,38.711ZM27.769,77.4,14.311,74.706h0A4.3,4.3,0,1,1,16,66.28h.015l11.749,2.35V77.4Zm2.514,2.385h0L44.069,74.27h0a4.3,4.3,0,1,1,3.193,7.981h-.006l-16.975,6.79V79.783ZM55.538,94.631l-25.255,10.1V91.749h0l17.908-7.164h0a6.812,6.812,0,0,0-5.055-12.652h0L30.283,77.075V68.453l25.255-10.1Zm0-38.988-25.255,10.1v-19.4l25.255-10.1ZM83.307,99.5,58.052,94.451V58.027L70.433,60.5l.052.008.045.007a1.27,1.27,0,0,0,.151.01,1.251,1.251,0,0,0,.151-.01h.027a1.144,1.144,0,0,0,.287-.077l.028-.011a1.267,1.267,0,0,0,.13-.064l.014-.009a1.255,1.255,0,0,0,.11-.074l.023-.017a1.254,1.254,0,0,0,.11-.1l.012-.013a1.262,1.262,0,0,0,.094-.107l.01-.012a1.248,1.248,0,0,0,.087-.13h0l4.751-8.229a6.811,6.811,0,1,0-11.679,0L68.2,57.493l-10.15-2.03V35.923L83.3,40.974Zm-16.3-49.1L67,50.381a4.3,4.3,0,1,1,7.361,0l-.013.022L70.68,56.756Z"
                    transform="translate(0 -33.133)" />
            </g>
            <g transform="translate(59.704 69.233)">
                <path fill={fill}
                    d="M366.975,262.717l-4.165-13.336a1.257,1.257,0,0,0-1.175-.882h-.025a1.257,1.257,0,0,0-1.184.835L356.26,261a1.257,1.257,0,0,0,.938,1.655l3.119.624V267.8a1.257,1.257,0,0,0,2.514,0v-4.021l2.7.54a1.257,1.257,0,0,0,1.447-1.607Zm-5.143-1.7h-.012l-2.7-.541,2.413-6.76,2.413,7.725Z"
                    transform="translate(-356.187 -248.499)" />
            </g>
            <g transform="translate(70.81 60.901)">
                <path fill={fill}
                    d="M433.236,213.016l-4.165-13.336a1.257,1.257,0,0,0-2.384-.048l-4.166,11.67a1.257,1.257,0,0,0,.937,1.655l3.119.624V218.1a1.257,1.257,0,1,0,2.514,0v-4.021l2.7.54a1.257,1.257,0,0,0,1.447-1.607Zm-5.143-1.7h-.011l-2.7-.541,2.413-6.76,2.413,7.726Z"
                    transform="translate(-422.448 -198.797)" />
            </g>
        </g>
    </svg>



export const EyeOpenPasswordIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "24",
    height = "24",
    percentageSize = 1,
    viewBox = "0 0 576 512",
    d = "M288 288a64 64 0 0 0 0-128c-1 0-1.88.24-2.85.29a47.5 47.5 0 0 1-60.86 60.86c0 1-.29 1.88-.29 2.85a64 64 0 0 0 64 64zm284.52-46.6C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 96a128 128 0 1 1-128 128A128.14 128.14 0 0 1 288 96zm0 320c-107.36 0-205.46-61.31-256-160a294.78 294.78 0 0 1 129.78-129.33C140.91 153.69 128 187.17 128 224a160 160 0 0 0 320 0c0-36.83-12.91-70.31-33.78-97.33A294.78 294.78 0 0 1 544 256c-50.53 98.69-148.64 160-256 160z",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d={d} fill={fill}> </path>
    </svg>

export const EyeClosePasswordIcon = ({
    style = {},
    fill = '#707070',
    className = '',
    width = "24",
    height = "24",
    percentageSize = 1,
    viewBox = "0 0 640 512",
    d = "M637 485.25L23 1.75A8 8 0 0 0 11.76 3l-10 12.51A8 8 0 0 0 3 26.75l614 483.5a8 8 0 0 0 11.25-1.25l10-12.51a8 8 0 0 0-1.25-11.24zM320 96a128.14 128.14 0 0 1 128 128c0 21.62-5.9 41.69-15.4 59.57l25.45 20C471.65 280.09 480 253.14 480 224c0-36.83-12.91-70.31-33.78-97.33A294.88 294.88 0 0 1 576.05 256a299.73 299.73 0 0 1-67.77 87.16l25.32 19.94c28.47-26.28 52.87-57.26 70.93-92.51a32.35 32.35 0 0 0 0-29.19C550.3 135.59 442.94 64 320 64a311.23 311.23 0 0 0-130.12 28.43l45.77 36C258.24 108.52 287.56 96 320 96zm60.86 146.83A63.15 63.15 0 0 0 320 160c-1 0-1.89.24-2.85.29a45.11 45.11 0 0 1-.24 32.19zm-217.62-49.16A154.29 154.29 0 0 0 160 224a159.39 159.39 0 0 0 226.27 145.29L356.69 346c-11.7 3.53-23.85 6-36.68 6A128.15 128.15 0 0 1 192 224c0-2.44.59-4.72.72-7.12zM320 416c-107.36 0-205.47-61.31-256-160 17.43-34 41.09-62.72 68.31-86.72l-25.86-20.37c-28.48 26.28-52.87 57.25-70.93 92.5a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448a311.25 311.25 0 0 0 130.12-28.43l-29.25-23C389.06 408.84 355.15 416 320 416z",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d={d} fill={fill}> </path>
    </svg>

export const DeleteClipIcon = ({
    style = {
        cursor: "pointer",
        margin: "0 5px 0 -6px"
    },
    fill = 'rgba(0, 0, 0, 0.26)',
    className = '',
    width = "22",
    height = "22",
    percentageSize = 1,
    viewBox = "0 0 24 24",
    d = "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d={d} fill={fill}> </path>
    </svg>

export const TrashUndoIcon = ({
    style = {
        cursor: "pointer",
    },
    fill = 'rgba(0, 0, 0, 0.26)',
    className = '',
    width = "22",
    height = "26",
    percentageSize = 1,
    viewBox = "0 0 448 512",
    d = "M440 64H336l-33.59-44.8C294.44 8.59 277.25 0 264 0h-80c-13.25 0-30.44 8.59-38.41 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.91l33.18 372.3c2.19 24.12 23.6 43.7 47.82 43.7h232.18c24.22 0 45.63-19.58 47.82-43.7L421.09 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.19 38.41A18.15 18.15 0 0 1 184 32h80a18.15 18.15 0 0 1 12.81 6.41L296 64H152zm184.81 427A16.2 16.2 0 0 1 340.16 480H107.84A16.2 16.2 0 0 1 92 465.41L59 96h330zM192.75 360.34A28 28 0 0 0 240 340v-52h16a48.05 48.05 0 0 1 48 48 16 16 0 0 0 32 0 80.09 80.09 0 0 0-80-80h-16v-52a28 28 0 0 0-47.25-20.34l-72 68a28 28 0 0 0 0 40.68zM208 213.28v117.44L145.81 272z",

}) =>
    <svg
        width={width * percentageSize}
        style={style}
        height={height * percentageSize}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d={d} fill={fill}> </path>
    </svg>

export const PhotoVideoIcon = ({
    style = {},
    fill = fill || '#19BC9B',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 640 512',
    d = "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z",
}) => {
    return (
        <svg
            width={width}
            style={style}
            height={height}
            viewBox={viewBox}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g transform="translate(-24 -8)">
                <path d={d} fill={fill} />
            </g>
        </svg>
    )
}

export const CameraRegulerIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '20',
    className = '',
    height = '18',
    viewBox = '0 0 512 512',
    d = "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>;


/* bars icon */
export const CheckLightIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '13.125',
    className = '',
    height = '15',
    viewBox = '0 0 448 512',
    d = "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
/* search bars icon */
export const SearchIcon = ({
    style = {},
    fill = 'var(--bgBlack)',
    width = '20',
    className = '',
    height = '15',
    viewBox = '0 0 512 512',
    d = "M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>

/* chevron up arrow  */
export const UpArrowIcon = ({
    style = {},
    fill = 'var(--bgBlack)',
    width = '13.75',
    className = '',
    height = '15',
    viewBox = '0 0 448 512',
    d = "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
/* chevron down arrow  */
export const DownArrowIcon = ({
    style = {},
    fill = 'var(--bgBlack)',
    width = '13.75',
    className = '',
    height = '15',
    viewBox = '0 0 448 512',
    d = "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>

/* circle down arrow  */
export const CircleDownIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm8.5-107.5l122.8-122.8c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L256 277.8l-91.7-91.7c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17l122.8 122.8c4.7 4.7 12.3 4.7 17 0z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
/* circle up arrow  */
export const CircleUpIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d = "M264.5 163.5l122.8 122.8c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 234.2l-91.7 91.7c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l122.8-122.8c4.7-4.7 12.3-4.7 17 0zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
/* circle up arrow  */
export const AngleUpIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 320 512',
    d = "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>

export const ThumbesUpIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d = "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>

export const TwitterFooterIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d = "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
export const GoogleFooterIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 640 512',
    d = "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
export const MapDuotoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '25',
    viewBox = '0 0 576 512',
    d = "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z",
}) =>

    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>
export const HotelDuotoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 640 512',
    d1 = "M528 128H304a16 16 0 0 0-16 16v144h352v-48a112 112 0 0 0-112-112zM176 96a80 80 0 1 0 80 80 80 80 0 0 0-80-80z",
    d2 = "M640 288v144a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-48H64v48a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v208z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d1} fill={fill} />
            <path d={d2} fill={fill} />
        </g>
    </svg>
export const PlaneDuotoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 576 512',
    d1 = "M214.86 192h150.85L260.61 8.06A16 16 0 0 0 246.71 0h-65.5a16 16 0 0 0-15.38 20.39zm-49 299.6a16 16 0 0 0 15.35 20.4h65.5a16 16 0 0 0 13.89-8.06L365.71 320H214.86z",
    d2 = "M480 320H112l-43.2 57.6A16 16 0 0 1 56 384H16A16 16 0 0 1 .49 364.12L32 256 .49 147.88A16 16 0 0 1 16 128h40a16 16 0 0 1 12.8 6.4L112 192h368c35.35 0 96 28.65 96 64s-60.65 64-96 64z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d1} fill={fill} />
            <path d={d2} fill={fill} />
        </g>
    </svg>
export const TrainDuotoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 448 512',
    d1 = "M376 96H72a24 24 0 0 0-24 24v112a24 24 0 0 0 24 24h304a24 24 0 0 0 24-24V120a24 24 0 0 0-24-24zm5 401.72L318 448H130l-63 49.72A8 8 0 0 0 72 512h304a8 8 0 0 0 5-14.28z",
    d2 = "M130 448h188c68.4 0 130-44.19 130-96V96c0-53-63-96-128-96H128C64 0 0 43 0 96v256c0 52 61.82 96 130 96zm94-40a56 56 0 1 1 56-56 56 56 0 0 1-56 56zM48 120a24 24 0 0 1 24-24h304a24 24 0 0 1 24 24v112a24 24 0 0 1-24 24H72a24 24 0 0 1-24-24z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d1} fill={fill} />
            <path d={d2} fill={fill} />
        </g>
    </svg>

export const BicycleIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = '0 0 24 24',
}) =>
    <svg
        xmlns="http://www.w3.org/2000/svg" width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}>
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill={fill} d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z" />
    </svg>


export const SubwayIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 448 512',
    d = "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>
export const BusIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 448 512',
    d = "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>
export const BusDuotoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 512 512',
    d1 = "M352 448v32a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32v-32zM64 480a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32v-32H64zm64-192h256a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32H128a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32z",
    d2 = "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h8v160a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V256h8a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24zm-392 0a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32zm16 272a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm288 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d1} fill={fill} />
            <path d={d2} fill={fill} />
        </g>
    </svg>
export const AngryIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '23',
    viewBox = '0 0 496 512',
    d = "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>

export const HappyIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '23',
    viewBox = '0 0 496 512',
    d = "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-24 -8)">
            <path d={d} fill={fill} />
        </g>
    </svg>


export const LeftQuoteIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '34',
    className = '',
    height = '24',
    viewBox = '0 0 34.473 24.339',
    d = "M7.647,9.412A7.646,7.646,0,0,0,7.2,24.691c.069.75.017,2.79-1.938,5.629a.538.538,0,0,0,.063.687c.8.8,1.295,1.3,1.641,1.657.453.461.66.671.962.946a.539.539,0,0,0,.715.008,20.648,20.648,0,0,0,6.645-16.6C14.971,12.611,11.756,9.412,7.647,9.412Z",
    d2 = "M50.808,17.019h0c-.322-4.407-3.538-7.606-7.645-7.606a7.646,7.646,0,0,0-.443,15.28c.069.749.017,2.789-1.939,5.629a.538.538,0,0,0,.063.687c.8.8,1.291,1.3,1.637,1.652.455.464.663.676.967.951a.539.539,0,0,0,.715.007A20.649,20.649,0,0,0,50.808,17.019Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(34.472 33.751) rotate(180)">
            <path d={d} fill={fill} />
            <path d={d2} fill={fill} transform="translate(-16.382)" />
        </g>
    </svg>;


export const RightQuoteIcon = ({
    style = {},
    fill = '#19BC9B',
    width = '34',
    className = '',
    height = '24',
    viewBox = '0 0 34.473 24.339',
    d = "M7.647,9.412A7.646,7.646,0,0,0,7.2,24.691c.069.75.017,2.79-1.938,5.629a.538.538,0,0,0,.063.687c.8.8,1.295,1.3,1.641,1.657.453.461.66.671.962.946a.539.539,0,0,0,.715.008,20.648,20.648,0,0,0,6.645-16.6C14.971,12.611,11.756,9.412,7.647,9.412Z",
    d2 = "M50.808,17.019h0c-.322-4.407-3.538-7.606-7.645-7.606a7.646,7.646,0,0,0-.443,15.28c.069.749.017,2.789-1.939,5.629a.538.538,0,0,0,.063.687c.8.8,1.291,1.3,1.637,1.652.455.464.663.676.967.951a.539.539,0,0,0,.715.007A20.649,20.649,0,0,0,50.808,17.019Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(0 -9.412)">
            <path d={d} fill={fill} />
            <path d={d2} fill={fill} transform="translate(-16.382)" />
        </g>
    </svg>;
export const AccountIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 448 512',
    d = "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>
export const FlightShapeIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '25',
    className = '',
    height = '20',
    viewBox = '0 0 31 31',
    d = "M28.962,6.26A8.971,8.971,0,0,0,31,1.525a1.751,1.751,0,0,0-.24-.967.773.773,0,0,0-.141-.18.812.812,0,0,0-.165-.129A1.724,1.724,0,0,0,29.474,0,8.947,8.947,0,0,0,24.741,2.04,40.794,40.794,0,0,0,20.08,6.531q-.485.511-1.024,1.075L15.364,6.5l.011-.011a.828.828,0,0,0,0-1.166l-.667-.668a.831.831,0,0,0-.587-.244.816.816,0,0,0-.585.242l-1,1-.528-.158A.827.827,0,0,0,11.941,4.4l-.67-.67a.829.829,0,0,0-.587-.241.81.81,0,0,0-.582.242l-.916.915L5.432,3.524a.94.94,0,0,0-.268-.038,1,1,0,0,0-.694.281L3.149,5.088a.778.778,0,0,0-.232.545.758.758,0,0,0,.4.679l7.9,4.411a1.377,1.377,0,0,1,.192.146l2.251,2.251c-2.106,2.218-3.981,4.367-5.443,6.236-.137.174-.266.343-.393.511L1.714,19.31a.828.828,0,0,0-.105-.006,1.127,1.127,0,0,0-.757.313l-.616.615A.764.764,0,0,0,0,20.776a.751.751,0,0,0,.444.691l4.3,2.041a1,1,0,0,1,.165.118l.357.354a2.608,2.608,0,0,0-.172.826,1.084,1.084,0,0,0,.3.792l.015.013,0,0a1.088,1.088,0,0,0,.79.3,2.63,2.63,0,0,0,.819-.17l.362.362a.979.979,0,0,1,.113.161l2.037,4.288a.759.759,0,0,0,.685.451h0a.764.764,0,0,0,.543-.229l.63-.633a1.123,1.123,0,0,0,.3-.755c0-.035,0-.062,0-.077l-.556-6.131c.167-.126.337-.256.511-.391,1.872-1.464,4.021-3.342,6.235-5.444L20.135,19.6a1.207,1.207,0,0,1,.147.193l4.4,7.882a.767.767,0,0,0,1.229.181l1.33-1.329a1.008,1.008,0,0,0,.272-.693.95.95,0,0,0-.036-.259l-1.125-3.756.915-.917a.828.828,0,0,0,0-1.168l-.671-.671a.828.828,0,0,0-1.092-.068l-.157-.526,1-1a.834.834,0,0,0,.241-.586.816.816,0,0,0-.241-.583l-.668-.668a.827.827,0,0,0-1.173,0l-.007.006-1.106-3.692c.382-.364.745-.711,1.091-1.037A40.64,40.64,0,0,0,28.962,6.26Z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const DollarSignIcon = ({
    style = {},
    fill = 'var(--mainWhite)',
    width = '10',
    className = '',
    height = '19',
    viewBox = '0 0 288 512',
    d = "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const PlusSignIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '16',
    viewBox = "0 0 448 512",
    d = "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const MinusSignIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '16',
    viewBox = "0 0 448 512",
    d = "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const HeartIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '15',
    viewBox = "0 0 512 512",
    d = "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const HeartEmptyIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '15',
    viewBox = "0 0 512 512",
    d = "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const DoneIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '15',
    viewBox = "0 0 512 512",
    d = `M4390 3799 c-35 -15 -311 -286 -1257 -1232 l-1213 -1212 -572 572
    c-436 436 -584 577 -618 592 -30 14 -66 21 -110 21 -110 0 -137 -19 -381 -266
    -235 -239 -239 -245 -239 -360 0 -37 8 -76 21 -104 15 -35 213 -239 872 -899
    939 -940 906 -911 1027 -911 124 0 25 -92 1667 1551 1169 1170 1497 1504 1512
    1539 29 65 28 160 -3 225 -32 68 -420 454 -486 484 -61 28 -159 28 -220 0z`,
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(0.000000,410.000000) scale(0.0940000,-0.0940000)"
            fill="#000000" stroke="none">
            <path d={d} fill={fill} /></g>
    </svg>

export const DoneEmptyIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '15',
    viewBox = "0 0 512 512",
    d = `M4535 4152 c-27 -10 -70 -31 -95 -46 -25 -16 -562 -546 -1195 -1180
    l-1150 -1151 -515 516 c-535 536 -562 559 -672 589 -29 7 -84 11 -140 8 -79
    -3 -103 -9 -163 -37 -63 -29 -94 -56 -302 -264 -208 -208 -235 -239 -264 -302
    -28 -60 -34 -84 -37 -163 -3 -56 1 -111 8 -140 31 -115 34 -118 944 -1028 562
    -562 888 -881 918 -899 130 -74 316 -74 446 0 64 37 3059 3032 3094 3095 47
    84 61 143 56 248 -3 84 -8 106 -36 167 -30 63 -58 94 -265 302 -207 207 -239
    235 -302 265 -63 29 -80 33 -175 35 -80 2 -117 -2 -155 -15z m371 -523 c106
    -105 198 -204 204 -220 7 -16 10 -39 6 -51 -3 -13 -676 -693 -1495 -1512
    -1428 -1428 -1492 -1490 -1526 -1490 -34 0 -74 38 -886 850 -467 467 -852 859
    -855 872 -4 12 -1 35 6 51 6 16 98 115 204 220 174 172 196 191 227 191 31 0
    79 -46 669 -635 l635 -635 1275 1275 c1191 1191 1277 1275 1309 1275 31 0 53
    -19 227 -191z`,
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(0.000000,410.000000) scale(0.0940000,-0.0940000)"
            fill="#000000" stroke="none">
            <path d={d} fill={fill} /></g>
    </svg>
export const LeftArrowChevronIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '20',
    viewBox = "0 0 320 512",
    d = "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const RightArrowChevronIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '15',
    className = '',
    height = '20',
    viewBox = "0 0 320 512",
    d = "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const SyncIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const CheckIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const CarIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const CaretLeft = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 192 512",
    d = "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const CaretRight = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 192 512",
    d = "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const AirplaneDestination = ({
    style = {},
    fill = '#19bc9b',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 54 54",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        transform='rotate(180)' 
    >
        <g ><g transform="translate(0 0)"><g transform="translate(0 0)">

            <path class="a" fill={fill}
                d="M57.842,23.475,51.6,20.637v-4a.757.757,0,0,0-.757-.757H44.153a.757.757,0,0,0-.757.757v.268l-3.5-1.592V8.733a9.079,9.079,0,0,0-6.382-8.7.756.756,0,0,0-.454,0,9.079,9.079,0,0,0-6.382,8.7v6.584l-3.5,1.592v-.268a.757.757,0,0,0-.757-.757H15.73a.757.757,0,0,0-.757.757v4L8.729,23.475a.757.757,0,0,0-.444.689V29.18a.757.757,0,0,0,.757.757h6a4.1,4.1,0,0,0,8.059,0h3.573v9.275a.756.756,0,0,0,.061.3l.5,1.166L21.919,45.33l-.015.014-.034.033-.021.024-.029.036-.018.025c-.009.013-.018.027-.027.04l-.015.024c-.009.015-.017.031-.024.047l-.01.022c-.008.017-.015.035-.021.053l-.007.019c-.006.019-.012.039-.016.059s0,.011,0,.016c0,.021-.008.042-.01.064,0,0,0,.009,0,.014a.774.774,0,0,0,0,.08v2.508a.757.757,0,0,0,.757.757h8.458l.878,2.049a.757.757,0,0,0,.7.459h1.672a.757.757,0,0,0,.7-.459l.878-2.049h8.458a.757.757,0,0,0,.757-.757V45.9a.746.746,0,0,0,0-.08s0-.009,0-.014c0-.022-.006-.043-.01-.064l0-.016c0-.02-.01-.04-.016-.06l-.007-.019c-.006-.018-.013-.036-.021-.054l-.01-.021c-.008-.016-.016-.032-.024-.047l-.015-.024c-.008-.014-.017-.027-.027-.04l-.019-.025-.029-.035-.022-.024-.033-.032-.015-.015-5.318-4.654.5-1.166a.757.757,0,0,0,.061-.3V29.937h3.573a4.1,4.1,0,0,0,8.059,0h6a.757.757,0,0,0,.757-.757V24.164A.756.756,0,0,0,57.842,23.475ZM12.465,28.423H9.8v-.994h2.666Zm0-2.508H9.8V24.652l2.666-1.212ZM33.285,1.554a7.635,7.635,0,0,1,1.867.954H31.418A7.626,7.626,0,0,1,33.285,1.554ZM16.487,17.4h5.174v.2l-5.174,2.352ZM13.979,28.423v-.994h4.338v.994Zm5.095,3.344a2.591,2.591,0,0,1-2.474-1.83h4.947A2.591,2.591,0,0,1,19.074,31.767Zm4.259-3.344h-3.5v-.994h3.5Zm3.344,0h-1.83v-.994h1.83Zm1.188,13.716,1.287,3h-4.72Zm-4.69,5.512v-.994H29.8l.426.994Zm12.4-2.05,0,.008-1.071,2.5,0,.007-.455,1.062V39.212a.757.757,0,1,0-1.514,0v9.967l-.455-1.062,0-.008L31,45.609l0-.008-2.151-5.02,0-.006-.651-1.518V29.181h0V23.753a.757.757,0,1,0-1.514,0v2.162h-12.7V22.751l12.7-5.772v3.748a.757.757,0,1,0,1.514,0V8.733a7.589,7.589,0,0,1,1.626-4.711h6.937A7.589,7.589,0,0,1,38.38,8.733V39.056l-.65,1.517,0,.011Zm7.82,2.05H36.344l.426-.994H43.4Zm-1.257-2.508h-4.72l1.287-3ZM44.91,17.4h5.174v2.551L44.91,17.6ZM41.724,28.423h-1.83v-.994h1.83Zm1.514,0v-.994h3.5v.994ZM47.5,31.767a2.591,2.591,0,0,1-2.474-1.83H49.97A2.591,2.591,0,0,1,47.5,31.767Zm5.095-3.344H48.254v-.994h4.338Zm0-2.508h-12.7V16.98l12.7,5.772v3.164Zm4.18,2.508H54.105v-.994h2.666Zm-2.666-2.508V23.44l2.666,1.212v1.264Z" transform="translate(-8.285 0)" />
        </g></g><g transform="translate(29.184 5.016)">
                <path class="a" fill={fill} d="M219.47,49.7a4.105,4.105,0,0,0-4.1,4.1.757.757,0,0,0,1.514,0,2.587,2.587,0,1,1,5.174,0,.757.757,0,1,0,1.514,0A4.106,4.106,0,0,0,219.47,49.7Z" transform="translate(-215.369 -49.698)" />
            </g></g>
    </svg>



export const TrainDestination = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 90.912 75.575",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Train" transform="translate(1 1)">
            <g id="BSicon_BAHN" transform="translate(0 0)">
                <g id="Group_1597" data-name="Group 1597">
                    <path id="Path_890" data-name="Path 890" d="M1331.978,186.9h-79.607c-3.791,0-8.271-7.02-8.271-11.562,0-7.845.345-15.691.345-23.123,1.034-8.671,3.791-16.517,6.548-24.362.689-1.652,1.723-3.3,3.446-3.3h28.6c2.757,1.239,5.514,2.478,6.548,6.194,8.271,24.362,24.813,35.924,43.422,40.053v14.865C1333.012,186.076,1332.323,186.9,1331.978,186.9Z" transform="translate(-1244.1 -124.551)" fill="rgba(13,58,125,0.2)" stroke={fill} stroke-width="2" fill-rule="evenodd" />
                    <path id="Path_891" data-name="Path 891" d="M1267.377,164.379h36.185c1.034,0,1.378-2.478.689-3.716-1.034-4.129-2.757-12.388-4.48-12.388h-27.914c-1.723,0-3.446,8.258-5.169,12.388C1266.343,162.314,1266.688,164.379,1267.377,164.379Z" transform="translate(-1261.863 -143.32)" fill={'#fff'}  stroke={fill} stroke-width="1.806" fill-rule="evenodd" />
                </g>
                <g id="Group_1593" data-name="Group 1593" transform="translate(4.824 37.988)">
                    <path id="lamp" d="M1275.2,310.224a3.888,3.888,0,0,1-3.789,4.211,4.219,4.219,0,0,1-4.211-4.211c0-2.105,2.105-3.789,4.211-3.789A3.774,3.774,0,0,1,1275.2,310.224Z" transform="translate(-1267.2 -306.435)" fill="#fff" stroke={fill} stroke-width="1.806" />
                    <path id="Path_892" data-name="Path 892" d="M1275.2,310.225a3.888,3.888,0,0,1-3.789,4.211,4.219,4.219,0,0,1-4.211-4.211c0-2.105,2.105-3.789,4.211-3.789A3.774,3.774,0,0,1,1275.2,310.225Z" transform="translate(-1239.63 -306.435)" fill="#fff" stroke={fill} stroke-width="1.806" />
                </g>
                <g id="Group_1594" data-name="Group 1594" transform="translate(48.592 23.123)">
                    <path id="Path_893" data-name="Path 893" d="M1482.953,242.283v14.452l-5.514-3.3c-.344-5.781-.689-11.975-.689-18.168C1478.818,237.328,1481.23,240.631,1482.953,242.283Z" transform="translate(-1476.75 -235.263)" fill="#fff" stroke={fill} stroke-width="1.7" fill-rule="evenodd" />
                    <path id="Path_894" data-name="Path 894" d="M1526.469,289.23l.345,11.149-5.514-2.89v-12.8C1523.712,287.165,1524.746,287.578,1526.469,289.23Z" transform="translate(-1511.995 -274.365)" fill="#fff" stroke={fill} stroke-width="1.5" fill-rule="evenodd" />
                    <path id="Path_895" data-name="Path 895" d="M1559.25,316.32v9.91a25.029,25.029,0,0,0,5.169,1.652V318.8Z" transform="translate(-1542.019 -299.39)" fill="#fff" stroke={fill} stroke-width="1.3" fill-rule="evenodd" />
                    <path id="Path_896" data-name="Path 896" d="M1593.9,334.113v8.671a14.713,14.713,0,0,0,4.135.826v-8.258Z" transform="translate(-1569.432 -313.467)" fill="#fff" stroke={fill} stroke-width="1" fill-rule="evenodd" />
                    <path id="Path_897" data-name="Path 897" d="M1623.6,344v7.845a9.871,9.871,0,0,0,3.446.413v-7.432Z" transform="translate(-1592.929 -321.288)" fill="#fff" stroke={fill} stroke-width="1" fill-rule="evenodd" />
                    <path id="Path_898" data-name="Path 898" d="M1648.35,349.929v7.433l2.757.413v-7.433Z" transform="translate(-1612.51 -325.98)" fill="#fff" stroke={fill} stroke-width="1" fill-rule="evenodd" />
                </g>
                <path id="Path_899" data-name="Path 899" d="M1244.1,437.092h6.892v-4.129h10.339v4.129h15.163v-4.129h56.518v4.129c-15.853.413-32.05,1.239-40.665,5.781H1244.1Z" transform="translate(-1244.1 -368.548)" fill="rgba(13,58,125,0.2)" stroke={fill} stroke-width="0.5" />
            </g>
            <path id="Path_900" data-name="Path 900" d="M-5.5.833,79.75,0V5H1.058Z" transform="translate(7.795 56.742)" fill="#fff" />
            <rect id="Rectangle_1055" data-name="Rectangle 1055" width="56" height="2" transform="translate(32.795 64.742)" fill="#fff" />
            <rect id="Rectangle_1056" data-name="Rectangle 1056" width="26" height="2" transform="translate(6.795 71.742)" fill="#fff" />
        </g>

    </svg>

export const HighwayDestination = ({
    style = {},
    fill = '#19bc9b',
    width = '20',
    className = '',
    height = '20',
    viewBox="0 0 43.307 44.866",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Highway" transform="translate(1.501 1.429)">
    <g id="Highway-2" data-name="Highway" transform="translate(-0.302 0)">
      <g id="Group_1649" data-name="Group 1649">
        <path id="path3849" d="M11.16,18.019H43.91M14.028,6.375,7.5,12.221c9.6,8.565-2.2,15.321,1.344,24.2,3.723,9.32,17.3,4.987,18.81,9.959,1.505-4.931,15.085-.6,18.808-9.919,3.545-8.874-8.256-15.629,1.345-24.194L41.279,6.417c-4.922,3.442-9.467,2.791-13.625-.033-4.159,2.784-8.7,3.434-13.626-.008Z" transform="translate(-7.199 -6.375)" fill="rgba(13,58,125,0.2)" stroke={fill} stroke-width="2"/>
        <rect  id="Rectangle_1057" data-name="Rectangle 1057" width="29.87" height="3.716" transform="translate(5.521 13.147)" fill="#fff"/>
        <g id="g3959" transform="translate(9.395 16.863)">
          <path fill={fill} id="path3955" d="M1527.271,2662.373q-.268,0-.627.02t-.794.081a9.234,9.234,0,0,0-2.542.64,7.392,7.392,0,0,0-2.076,1.287,7.2,7.2,0,0,0-1.754,2.459,8.486,8.486,0,0,0-.688,3.422,5.846,5.846,0,0,0,1.4,4.052,4.895,4.895,0,0,0,3.71,1.508,4.789,4.789,0,0,0,3.521-1.4,4.584,4.584,0,0,0,1.274-3.2,4.13,4.13,0,0,0-1.218-3.064,4.444,4.444,0,0,0-3.133-1.151,4.9,4.9,0,0,0-2.084.444,4.062,4.062,0,0,0-1.4,1.061h-.067a5.32,5.32,0,0,1,1.485-2.951,6.169,6.169,0,0,1,3.532-1.686q.419-.06.791-.078t.674,0Zm-3.375,12.1a2.865,2.865,0,0,1-2.337-1.062,4.388,4.388,0,0,1-.838-2.672,1.516,1.516,0,0,1,.061-.437,1.3,1.3,0,0,1,.161-.346,3.155,3.155,0,0,1,1.157-1.156,3.267,3.267,0,0,1,1.64-.449,2.775,2.775,0,0,1,2.975,2.991,3.344,3.344,0,0,1-.774,2.266,2.643,2.643,0,0,1-2.023.865Z" transform="translate(-1518.79 -2662.373)" />
          <path fill={fill} id="path3957" d="M1806.137,2662.373q-.267,0-.627.02t-.794.081a9.236,9.236,0,0,0-2.542.64,7.39,7.39,0,0,0-2.075,1.287,7.2,7.2,0,0,0-1.754,2.459,8.488,8.488,0,0,0-.688,3.422,5.847,5.847,0,0,0,1.4,4.052,4.895,4.895,0,0,0,3.71,1.508,4.79,4.79,0,0,0,3.521-1.4,4.585,4.585,0,0,0,1.274-3.2,4.13,4.13,0,0,0-1.218-3.064,4.445,4.445,0,0,0-3.133-1.151,4.9,4.9,0,0,0-2.084.444,4.062,4.062,0,0,0-1.4,1.061h-.066a5.319,5.319,0,0,1,1.484-2.951,6.17,6.17,0,0,1,3.533-1.686q.418-.06.791-.078t.674,0Zm-3.374,12.1a2.865,2.865,0,0,1-2.337-1.062,4.386,4.386,0,0,1-.838-2.672,1.516,1.516,0,0,1,.061-.437,1.3,1.3,0,0,1,.161-.346,3.155,3.155,0,0,1,1.157-1.156,3.266,3.266,0,0,1,1.64-.449,2.775,2.775,0,0,1,2.975,2.991,3.345,3.345,0,0,1-.774,2.266,2.644,2.644,0,0,1-2.023.865Z" transform="translate(-1786.254 -2662.373)" />
        </g>
      </g>
    </g>
    <g id="flowRoot3866" transform="translate(11.435 4.383)">
      <path fill={fill} id="path3879" d="M130.6,432.071h.552v-1.853h.52a.814.814,0,0,1,.569.2,1.2,1.2,0,0,1,.288.63q.09.4.162.663a1.935,1.935,0,0,0,.124.359h.571a2.279,2.279,0,0,1-.146-.425q-.08-.3-.184-.749a1.562,1.562,0,0,0-.228-.555.8.8,0,0,0-.4-.308v-.019a1.223,1.223,0,0,0,.572-.391,1.1,1.1,0,0,0,.234-.7,1.2,1.2,0,0,0-.087-.458.955.955,0,0,0-.249-.354,1.212,1.212,0,0,0-.5-.265,2.742,2.742,0,0,0-.74-.084q-.29,0-.568.023a4.294,4.294,0,0,0-.492.066Zm.552-3.832a1.291,1.291,0,0,1,.206-.035,3.341,3.341,0,0,1,.339-.016,1.2,1.2,0,0,1,.711.2.711.711,0,0,1,.273.6.748.748,0,0,1-.261.589,1.07,1.07,0,0,1-.7.223h-.565Z" transform="translate(-130.603 -427.725)"/>
      <path fill={fill} id="path3881" d="M232.8,426.552a1.875,1.875,0,0,0-1.421.614,2.393,2.393,0,0,0-.565,1.632,2.321,2.321,0,0,0,.538,1.57,1.811,1.811,0,0,0,1.385.6,1.9,1.9,0,0,0,1.4-.574,2.369,2.369,0,0,0,.584-1.678,2.331,2.331,0,0,0-.523-1.558A1.8,1.8,0,0,0,232.8,426.552Zm-.025.451a1.206,1.206,0,0,1,1.027.55,2.319,2.319,0,0,1-.02,2.44,1.237,1.237,0,0,1-2.022,0,2.067,2.067,0,0,1-.356-1.209,2.2,2.2,0,0,1,.343-1.244A1.205,1.205,0,0,1,232.776,427Z" transform="translate(-227.661 -426.552)" />
      <path fill={fill} id="path3883" d="M377.678,428.778V431.3a1.989,1.989,0,0,0,.439,1.411,1.449,1.449,0,0,0,1.1.416,1.552,1.552,0,0,0,1.156-.434,1.97,1.97,0,0,0,.462-1.419v-2.494h-.558v2.532a1.619,1.619,0,0,1-.282,1.037.927.927,0,0,1-.758.328.874.874,0,0,1-.712-.323,1.638,1.638,0,0,1-.284-1.041v-2.532Z" transform="translate(-369.902 -428.708)" />
      <path fill={fill} id="path3885" d="M493.99,433.048h.558v-3.807h1.307v-.47h-3.166v.47h1.3Z" transform="translate(-481.293 -428.701)" />
      <path fill={fill} id="path3887" d="M610.436,430.587h-1.662v-1.351h1.758v-.463h-2.31v4.277h2.4v-.463h-1.853v-1.542h1.662Z" transform="translate(-593.189 -428.703)" />
    </g>
  </g>
    </svg>




export const WalkIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 320 512",
    d = "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>




export const DirectionsIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const MapMarkerIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 384 512",
    d = "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const InfoCircleIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const WebsiteIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 496 512",
    d = "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const EnvelopeIcon = ({
    style = {},
    fill = 'var(--mainGreen)',
    width = '20',
    className = '',
    height = '20',
    viewBox = "0 0 512 512",
    d = "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const CameraSolidIcon = ({
    style = {},
    fill = "#C7C7C775",
    width = "250",
    className = "",
    height = "220",
    viewBox = "0 0 512 512",
    d = "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const PlusCircleIcon = ({
    style = {},
    fill = "#C7C7C775",
    width = "250",
    className = "",
    height = "220",
    viewBox = "0 0 512 512",
    d = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const TimelineIcon = ({
    style = {},
    fill = "#C7C7C7",
    width = "250",
    className = "",
    height = "220",
    viewBox = "0 0 512 512",
    d1 = "M512 224v64a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16z",
    d2 = "M432 32H16A16 16 0 0 0 0 48v64a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 352H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d1} fill={fill} />
        <path d={d2} fill={fill} />
    </svg>


export const CalendarAltIcon = ({
    style = {},
    fill = "#C7C7C775",
    width = "250",
    className = "",
    height = "220",
    viewBox = "0 0 448 512",
    d = "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const LinkIcon = ({
    style = {},
    fill = "#C7C7C775",
    width = "20",
    className = "",
    height = "20",
    viewBox = "0 0 512 512",
    d = "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const UserPlusIcon = ({
    style = {},
    fill = "#FFFFFF",
    width = "20",
    className = "",
    height = "20",
    viewBox = "0 0 640 512",
    d = "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const ImageIcon = ({
    style = {},
    fill = "#19EB9B",
    width = "15",
    className = "",
    height = "14",
    viewBox = "0 0 576 512",
    d = "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const ClockIcon = ({
    style = {},
    fill = "#707070",
    width = "16",
    className = "",
    height = "16",
    viewBox = "0 0 512 512",
    d = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>


export const PlaneDepartureIcon = ({
    style = {
        marginLeft: "2px",
        marginRight: "13px",
    },
    fill = "#707070",
    width = "16",
    className = "",
    height = "16",
    viewBox = "0 0 640 512",
    d = "M80.52 339.28A40.69 40.69 0 0 0 110.06 352l127.06-.17a73.86 73.86 0 0 0 32.45-7.61l283.1-140.31c29.18-14.46 52.82-34.58 68.36-58.18 18-27.27 22.38-50.28 13.16-68.4-11.59-22.86-42-30.76-72.7-30.76-26 0-52.45 6.61-78.76 19.64l-92.71 46-208.71-76.54A25.67 25.67 0 0 0 168 32a26 26 0 0 0-11.45 2.68l-64 31.7a25.07 25.07 0 0 0-13.8 19.32A24 24 0 0 0 90.2 109l136.53 84.1-83.95 41.61L76 201.83a25.86 25.86 0 0 0-22.84 0l-39.07 19.38A25.11 25.11 0 0 0 .51 238.8a24.87 24.87 0 0 0 5.67 21.41zM64.6 231.87l78.22 38.51 149.94-74.31L118.54 89.23l49.28-24.42 224.09 82.12 105-52c21.85-10.83 43.58-16.32 64.59-16.32 16.3 0 39.32 3.6 44.23 13.28 3.41 6.71-.84 20.26-11.36 36.26-12.43 18.87-31.74 35.17-55.85 47.12L255.41 315.54a41.63 41.63 0 0 1-18.32 4.29l-127 .17a8.77 8.77 0 0 1-6.29-2.66l-67.3-71.53 28.1-13.94zM632 448H9.1a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8H632a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>

export const PlaneArrivalIcon = ({
    style = {
        marginLeft: "2px",
        marginRight: "13px",
    },
    fill = "#707070",
    width = "16",
    className = "",
    height = "16",
    viewBox = "0 0 640 512",
    d = "M632 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-51.56-177.46c-19.46-20.21-45.93-35.35-76.55-43.77l-96.94-26.68L310.5 46.83c-2.19-4.23-4.15-8.58-6.18-12.89-3.14-6.64-8.97-11.67-16.05-13.62C269.1 15.05 216.78 0 216.78 0c-.28 0-10.77-.48-18.69 8.65-5.41 6.25-7.37 16.41-5.09 24.35l42.32 151.85-87.29-24.02-26.88-67.79c-2.92-7.47-9.18-13.18-16.75-15.26C59.87 65.53 61.43 65.64 57 65.64c-13.55 0-24.77 11.34-25 25.29l.29 107.22c.25 11.54 5.21 22.55 13.62 30.21l93.32 83.17c8.42 7.67 18.62 13.31 29.49 16.3l295.95 81.45c16.21 4.46 32.32 6.73 47.88 6.73 13.79 0 27.15-1.79 39.71-5.33 30.87-8.69 49.14-23.15 54.31-43 5.17-19.85-3.61-41.76-26.13-65.14zm-4.86 57.07c-2.01 7.72-13.67 15.1-32.01 20.26-30.85 8.68-60.03 1.41-70.42-1.45L177.2 296.97c-6.03-1.66-11.72-4.81-16.43-9.1L67.45 204.7c-1.93-1.76-3.11-4.46-3.17-7.23l-.1-97.57 28.35 7.8 31.54 79.72 157.85 43.44-54.51-194.65 48.8 13.98 108.76 209.03 110.44 30.4c25.08 6.9 46.51 19.04 61.99 35.11 13.64 14.18 20.28 26.88 18.18 34.88z",
}) =>
    <svg
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d={d} fill={fill} />
    </svg>